import React, { Component } from "react";
import {
  Chip,
  Paper,
  Grid,
  Button,
  Tabs,
  Tab,
  FormControlLabel,
  withStyles,
  Switch,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  CircularProgress,
  ButtonGroup,
  Typography,
  FormControl,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import col from "./Columns";
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import clsx from "clsx";
import { connect } from "react-redux";
import { styles } from "./Styles.css";
import { loadRuntime } from "redux/actions/OrgRuntimeActions";
import {
  bulkEditInvoke,
  search,
  albumSearch,
  setQuery,
  editItem,
  albumEditItem,
  bulkEditSave,
  jobEditItems,
  getValidationItems,
  commonEditItem,
  albumCommonEditItem,
  showAutoMessage,
  bulkEditPublish,
  bulkEditUploadImage,
  getListOfCountries,
  getListOfOrigins,
  getListOfDecades,
  getListOfVocals,
  getListOfAlbumTypes,
  setErrorMessage,
} from "../../redux/actions/BulkEditAction";
import {
  applicationNames,
  bulkEditStringTypes,
  bulkEditTypesENUM,
  checkAlbumAppendValues,
  checkTrackAppendValues,
} from "../../redux/Types";
import { FilterOperatorTypes } from "util/table-view/TableTypes";
import TracksCommonUpdates from "./TracksCommonUpdates";
import TracksSingleSpecificUpdates from "./TracksSingleSpecificUpdates";
import AlbumCommonUpdates from "./AlbumCommonUpdates";
import AlbumSingleSpecificUpdates from "./AlbumSingleSpecificUpdates";
import InfoIcon from "@material-ui/icons/Info";
import Confirm from "util/Confirm";
import { MdClose, MdEdit, MdFilterAltOff, MdFilterList, MdFilterListAlt, MdFilterListOff } from "react-icons/md";
import CloseIcon from "@material-ui/icons/Close";
import FilterIcon from '@material-ui/icons/FilterList';
import Tooltip from "@material-ui/core/Tooltip";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import i18n from "i18next";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableDataCol from "util/TableDataCol";
import TableHeaderCol from "util/TableHeaderCol";
import store from "redux/Store";

export class BulkEdit extends Component {
  constructor(props) {
    super();
    this.state = {
      messageOpen: false,
      isDialogOpen: false,
      isSessionSave: false,
      checked: true,
      currentTab: null,
      editSingleTrack_bulkEdit: true,
      editSingleAlbum_bulkEdit: true,
      editAlbumAppendValues: true,
      editTrackAppendValues: true,
      trackIds: [],
      albumIds: [],
      currentTrackIndex: 0,
      currentAlbumIndex: 0,
      currentTrackId: "",
      currentAlbumId: "",
      invokedBulkJob: null,
      companyDetails: "",
      librarianNotes: "",
      prodNotes: "",
      albumCompanyDetailsAppendFalse: "",
      albumLibrarianNotesAppendFalse: "",
      albumProdNotesAppendFalse: "",
      commonCompanyDetails: "",
      commonLibrarianNotes: "",
      commonProdNotes: "",
      trackLyrics: "",
      trackLibrarianNotes: "",
      trackTrackNotes: "",
      trackLyricsAppendFalse: "",
      trackLibrarianNotesAppendFalse: "",
      trackTrackNotesAppendFalse: "",
      commonTrackLyrics: "",
      commonTrackLibrarianNotes: "",
      commonTrackNotes: "",
      sessionNameError: false,
      applicationName: "",
      errorDialogOpen: false,
      errorDialogMessage: "",

      //Tagging states
      tagConfirmationOpen: false,
      tagConfirmationMessage: false,
      tagConfirmationType: null,

      keywords: [],            // all available keywords from backend
      selectedKeywords: [],    // currently selected keywords in the UI
      keywordsLoading: false,  // loading state for keywords
      keywordSearch: '',       // current search input for keywords suggestions
      allCurrentKeywords: [],  // all keywords currently in the track list
      originalTracks: [],      // original track list from backend
      displayingTracks: [],    // track list after applying tagging updates and filtering
      tracksLoading: false,    // loading state for track fetching
      tagFilters: [],          // active tag filters applied to the track list
      applyTagChangesToAllTracks: false, // whether to apply tag changes to all tracks
    };
    this.keywordSearchDebounce = null;
    this.handleTrackValueChange = this.handleTrackValueChange.bind(this);
    this.timeoutId = null;
  }

  async componentDidMount() {
    store.dispatch(loadRuntime());
    const {
      match: {
        params: { handle: jobId, type: bulkEditType, org: orgId },
      },
    } = this.props;
    this.getCountries();
    this.getOrigins();
    this.getVocal();
    this.getDecades();
    this.getAlbumTypes();
    try {
      const invokedJob = await this.invokeBulkEdit(jobId, orgId);

      this.setState({ invokedBulkJob: invokedJob });

      if (bulkEditType == bulkEditStringTypes.TRACK) {
        if (
          invokedJob &&
          invokedJob.selected_tracks &&
          invokedJob.selected_tracks.length > 0
        ) {
          this.setState({ applicationName: applicationNames.BULK_EDIT });
          this.setState({ currentTab: bulkEditTypesENUM.TRACK });
        } else {
          if (
            invokedJob &&
            invokedJob.selected_albums &&
            invokedJob.selected_albums.length > 0
          ) {
            this.setState({ applicationName: applicationNames.BULK_EDIT });
            this.setState({ currentTab: bulkEditTypesENUM.ALBUM });
          }
        }
      } else {
        this.setState({ applicationName: applicationNames.BULK_EDIT });
        this.setState({ currentTab: bulkEditTypesENUM.ALBUM });
      }

      if (
        invokedJob &&
        invokedJob.selected_tracks &&
        invokedJob.selected_tracks.length === 1
      ) {
        if (bulkEditType == bulkEditStringTypes.TRACK) {
          this.checkSelectedTrackIsSingle();
        }
      } else {
        if (
          invokedJob &&
          invokedJob.selected_albums &&
          invokedJob.selected_albums.length === 1
        ) {
          if (bulkEditType == bulkEditStringTypes.ALBUM) {
            this.checkSelectedAlbumIsSingle();
          } else {
            this.checkSelectedAlbumIsSingle();
          }
        }
      }
      window.addEventListener("beforeunload", this.handleBeforeUnload);
    } catch (error) {
      console.error("Error in componentDidMount:", error);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.keywordSearchDebounce);
    clearTimeout(this.timeoutId);
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }


  //#region tagging helpers

  // ---------- Backend fetch helpers ----------

  setColumns = () => {
    this.columns = [
      // "player",
      // "downloader",
      "trackTitle",
      "performer",
      "prodName",
      "keywords",
      "duration",
    ].map((v) => {
      return {
        ...(col[v] || {}),
        type: col[v].type,
        field: v,
        label: i18n.t(`track.${v}`),
      };
    });
  };

  fetchTracks = async () => {
    var tracks = [];
    this.setState({ tracksLoading: true });

    try {
      const {
        bulkEditData: { job },
        match: {
          params: { org: orgId },
        },
      } = this.props;

      const options = {
        headers: {
          Authorization: `${localStorage.auth0IdToken}`
        },
      };

      var res = await axios.post("/librarysearch", {
        filters: [{ value: job.selected_tracks ?? [], operator: "equals", field: "id" }],
        orgId, order: "desc", page: 0, size: 1000
      }, options);
      tracks = res.data.data ?? [];

      if (job?.selected_tracks?.length && tracks.length) {
        const orderMap = new Map(
          job.selected_tracks.map((id, idx) => [id, idx])
        );
        tracks.sort((a, b) => {
          const ai = orderMap.get(a.id);
          const bi = orderMap.get(b.id);
          // Put missing ids at the end (Infinity)
          return (ai !== undefined ? ai : Number.MAX_SAFE_INTEGER) -
            (bi !== undefined ? bi : Number.MAX_SAFE_INTEGER);
        });
      }
    }
    catch (err) {
      console.error(err);
      return [];
    } finally {
      this.setState({ originalTracks: tracks, tracksLoading: false }, this.prepareTracksForDisplay);
    }
  };

  fetchWithCancel = async (fields, query, size = 10) => {
    const {
      match: {
        params: { org: orgId },
      },
    } = this.props;
    const options = {
      headers: {
        Authorization: `${localStorage.auth0IdToken}`
      },
    };

    try {
      var res = await axios.post("/tracksuggestions", { fields, query, size, orgId }, options);
      return res.data.payload;
    }
    catch (err) {
      console.error(fields, err);
      return [];
    }
  };

  fetchKeywords = async (query = '', size = 10) => {
    this.setState({ keywordsLoading: true });
    var mapped = [];
    try {
      const data = await this.fetchWithCancel(
        ['keywords'], query, size
      );
      if (query.trim() == '' || data?.["keywords"]?.some(k => k.label?.trim()?.toLowerCase() == query?.trim()?.toLowerCase())) {
        mapped = (data?.["keywords"] || []).map(k => ({ type: 'keyword', label: k.label }));
      }
      else {
        mapped = [{ type: 'keyword', label: query, isNew: true }, ...((data?.["keywords"] || []).map(k => ({ type: 'keyword', label: k.label })))];
      }
    } finally {
      this.setState({ keywords: mapped, keywordsLoading: false });
    }
  };

  tagUpdateConfirmation = (message, type) => {
    this.setState({ tagConfirmationOpen: true, tagConfirmationMessage: message, tagConfirmationType: type });
  };

  applyTagChanges = () => {
    const { tagConfirmationType, selectedKeywords, applyTagChangesToAllTracks, originalTracks, displayingTracks } = this.state;
    const {
      bulkEditData: { job },
    } = this.props;
    var trackSpecificUpdates = { ...job.track_specific_updates } || {};
    for (var track of applyTagChangesToAllTracks ? originalTracks : displayingTracks) {
      var taggingUpdates = (trackSpecificUpdates[track.id] || {})['tagging_updates'] || {};
      switch (tagConfirmationType) {
        case "keywords_add":
          if (selectedKeywords?.length > 0) {
            taggingUpdates['keywords_add'] = [...(taggingUpdates['keywords_add'] || []).filter(ka => !selectedKeywords.some(ks => ks.label?.trim()?.toLowerCase() == ka.label?.trim()?.toLowerCase())), ...selectedKeywords];
          }
          if (taggingUpdates['keywords_remove'] && taggingUpdates['keywords_remove'].length > 0) {
            taggingUpdates['keywords_remove'] = taggingUpdates['keywords_remove'].filter(kr => !selectedKeywords.some(ks => ks.label?.trim()?.toLowerCase() == kr.label?.trim()?.toLowerCase()));
          }
          break;
        case "keywords_remove":
          if (selectedKeywords?.length > 0) {
            taggingUpdates['keywords_remove'] = [...(taggingUpdates['keywords_remove'] || []).filter(ka => !selectedKeywords.some(ks => ks.label?.trim()?.toLowerCase() == ka.label?.trim()?.toLowerCase())), ...selectedKeywords];
          }
          if (taggingUpdates['keywords_add'] && taggingUpdates['keywords_add'].length > 0) {
            taggingUpdates['keywords_add'] = taggingUpdates['keywords_add'].filter(ka => !selectedKeywords.some(ks => ks.label?.trim()?.toLowerCase() == ka.label?.trim()?.toLowerCase()));
          }
          break;
        default:
          break;
      }
      trackSpecificUpdates[track.id] = { ...(trackSpecificUpdates[track.id] || {}), tagging_updates: taggingUpdates };
    }
    job.track_specific_updates = trackSpecificUpdates;
    this.setState({ tagConfirmationOpen: false, tagConfirmationMessage: '', tagConfirmationType: null, selectedKeywords: [], dirty: true }, this.prepareTracksForDisplay);
  };

  tagUpdateCancelled = () => {
    this.setState({ tagConfirmationOpen: false, tagConfirmationMessage: '', tagConfirmationType: null });
  };

  prepareTracksForDisplay = () => {
    const { originalTracks } = this.state;
    const {
      bulkEditData: { job },
    } = this.props;

    var trackSpecificUpdates = { ...job.track_specific_updates } || {};
    var updatedTracks = [];

    originalTracks.forEach(track => {
      var newTrack = { ...track };
      if (track.id in trackSpecificUpdates) {
        const taggingUpdates = trackSpecificUpdates[track.id]['tagging_updates'] || {};

        // Normalize existing keywords to string array
        const existing = Array.isArray(newTrack.keywords)
          ? newTrack.keywords.map(s => String(s).trim()).filter(Boolean)
          : (newTrack.keyword ? [String(newTrack.keyword).trim()] : []);

        let working = [...existing];

        // REMOVALS
        if (Array.isArray(taggingUpdates.keywords_remove) && taggingUpdates.keywords_remove.length) {
          const removeSet = new Set(
            taggingUpdates.keywords_remove
              .map(r => r.label)
              .filter(Boolean)
              .map(v => v.trim().toLowerCase())
          );
          working = working.filter(k => !removeSet.has(k.trim().toLowerCase()));
        }

        // ADDITIONS
        if (Array.isArray(taggingUpdates.keywords_add) && taggingUpdates.keywords_add.length) {
          const addList = taggingUpdates.keywords_add
            .map(a => a.label)
            .filter(Boolean)
            .map(v => v.trim());
          const seen = new Set(working.map(k => k.toLowerCase()));
          addList.forEach(k => {
            const low = k.toLowerCase();
            if (!seen.has(low)) {
              seen.add(low);
              working.push(k);
            }
          });
        }

        newTrack.keywords = working;
      }
      updatedTracks.push(newTrack);
    });

    var displayingTracks = [];
    const counter = Object.create(null);

    // Collect ALL tags from ALL updated tracks (case-insensitive key -> display value)
    const allTagsLowerToDisplay = new Map();
    updatedTracks.forEach(t => {
      const kws = Array.isArray(t.keywords) ? t.keywords : (t.keyword ? [t.keyword] : []);
      kws.forEach(k => {
        if (!k) return;
        const disp = String(k).trim();
        if (!disp) return;
        const lower = disp.toLowerCase();
        if (!allTagsLowerToDisplay.has(lower)) {
          allTagsLowerToDisplay.set(lower, disp);
        }
      });
    });

    if (this.state.tagFilters.length > 0) {
      displayingTracks = updatedTracks.filter(t =>
        this.state.tagFilters.every(f =>
          t.keywords?.some(k => f.label?.trim()?.toLowerCase() === k?.trim()?.toLowerCase())
        )
      );
    } else {
      displayingTracks = updatedTracks;
    }

    // Count ONLY displayed tracks
    displayingTracks.forEach(t => {
      const kws = Array.isArray(t.keywords) ? t.keywords : (t.keyword ? [t.keyword] : []);
      kws.forEach(k => {
        if (!k) return;
        const lower = String(k).trim().toLowerCase();
        if (!lower) return;
        counter[lower] = (counter[lower] || 0) + 1;
      });
    });

    // If filtering, add ZERO count entries for tags not present in filtered result
    if (this.state.tagFilters.length > 0) {
      allTagsLowerToDisplay.forEach((disp, lower) => {
        if (!(lower in counter)) counter[lower] = 0;
      });
    }

    const allCurrentKeywords = Object.entries(counter)
      .map(([lower, count]) => ({
        value: allTagsLowerToDisplay.get(lower) || lower,
        count
      }))
      .sort((a, b) =>
        a.value.localeCompare(b.value, undefined, { sensitivity: 'base' }) ||
        b.count - a.count
      );

    this.setState({ allCurrentKeywords, displayingTracks });
  };

  handleKeywordInputChange = (event, value, reason) => {
    var lowerValue = value?.trim().toLowerCase() || '';
    if (value && value.includes(',')) {
      const parts = value.split(',').map(s => s.trim()).filter(Boolean);
      const deduped = [...this.state.selectedKeywords];
      if (parts.length > 0) {
        const seen = new Set(deduped.map(k => k.label?.toLowerCase()));
        parts.forEach(part => {
          const key = part.toLowerCase();
          if (!seen.has(key)) {
            deduped.push({ type: 'keyword', label: part });
            seen.add(key);
          }
        });
      }
      this.setState({ selectedKeywords: deduped, keywordSearch: '' });
      lowerValue = '';
    }

    if (lowerValue !== this.state.keywordSearch && reason === 'input') {
      clearTimeout(this.keywordSearchDebounce);
      this.setState({ keywordSearch: lowerValue }, () =>
        this.keywordSearchDebounce = setTimeout(() => this.fetchKeywords(lowerValue), 350)
      );
    }
  };

  onKeywordChange = (event, value) => {
    const deduped = [];
    const seen = new Set();

    (value || []).forEach(item => {
      if (item == null || !item.label) return;

      const rawLabel = item.label;
      const clean = (rawLabel || '').trim();
      if (!clean) return;

      const key = clean.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);

      // Preserve other props (e.g. isNew) from first instance
      deduped.push(
        typeof item === 'string'
          ? { type: 'keyword', label: clean }
          : { ...item, label: clean }
      );
    });

    this.setState({ selectedKeywords: deduped });

    // Optionally refresh suggestions after selection change
    this.fetchKeywords("", 20);
  };

  //#endregion

  //#region bulk edit helpers

  checkSelectedTrackIsSingle = () => {
    this.setState({ editSingleTrack_bulkEdit: false });
    const { currentTrackIndex, invokedBulkJob } = this.state;
    this.setState({ applicationName: applicationNames.TRACK });
    this.setState({ editTrackAppendValues: true });
    if (currentTrackIndex < invokedBulkJob.selected_tracks?.length) {
      const checkCurrentIndex =
        currentTrackIndex == -1 ? currentTrackIndex : currentTrackIndex - 1;
      // const nextIndex = currentTrackIndex + 1;
      const nextIndex = checkCurrentIndex + 1;
      this.setState({ currentTrackIndex: nextIndex });
      const currentId = invokedBulkJob.selected_tracks[nextIndex];
      this.setState({ currentTrackId: currentId });
      this.editTrackAppendTrue(currentId);
      this.searchTrackById(currentId);
    }
  };

  handleBeforeUnload = (event) => {
    const { dirty } = this.state;
    if (dirty) {
      const message =
        "You have unsaved changes. Are you sure you want to leave this page?";
      event.returnValue = message;
      return message;
    }
  };

  checkSelectedAlbumIsSingle = () => {
    this.setState({ editSingleAlbum_bulkEdit: false });
    const { currentAlbumIndex, invokedBulkJob } = this.state;
    this.setState({ applicationName: applicationNames.ALBUM });
    this.setState({ editAlbumAppendValues: true });
    if (currentAlbumIndex < invokedBulkJob?.selected_albums?.length) {
      const checkCurrentIndex =
        currentAlbumIndex == -1 ? currentAlbumIndex : currentAlbumIndex - 1;
      // const nextIndex = currentTrackIndex + 1;
      const nextIndex = checkCurrentIndex + 1;
      this.setState({ currentAlbumIndex: nextIndex });
      const currentId = invokedBulkJob.selected_albums[nextIndex];
      this.setState({ currentAlbumId: currentId });
      this.editAlbumAppendTrue(currentId);
      this.searchAlbumById(currentId);
    }
  };

  getCountries = async () => {
    const {
      getListOfCountries,
      match: {
        params: { org: orgId },
      },
    } = this.props;
    try {
      const data = await new Promise((resolve, reject) => {
        getListOfCountries({ org_id: orgId }, (data, error) => {
          if (data) {
            resolve(data);
          } else if (error) {
            reject(error);
          }
        });
      });
      return data;
    } catch (error) {
      console.error("Error in get Countries:", error);
    }
  };

  getOrigins = async () => {
    const {
      getListOfOrigins,
      match: {
        params: { org: orgId },
      },
    } = this.props;
    try {
      const data = await new Promise((resolve, reject) => {
        getListOfOrigins({ org_id: orgId }, (data, error) => {
          if (data) {
            resolve(data);
          } else if (error) {
            reject(error);
          }
        });
      });
      return data;
    } catch (error) {
      console.error("Error in get Origins:", error);
    }
  };

  getVocal = async () => {
    const {
      getListOfVocals,
      match: {
        params: { org: orgId },
      },
    } = this.props;
    try {
      const data = await new Promise((resolve, reject) => {
        getListOfVocals({ org_id: orgId }, (data, error) => {
          if (data) {
            resolve(data);
          } else if (error) {
            reject(error);
          }
        });
      });
      return data;
    } catch (error) {
      console.error("Error in get Vocal:", error);
    }
  };

  getAlbumTypes = async () => {
    const {
      getListOfAlbumTypes,
      match: {
        params: { org: orgId },
      },
    } = this.props;
    try {
      const data = await new Promise((resolve, reject) => {
        getListOfAlbumTypes({ org_id: orgId }, (data, error) => {
          if (data) {
            resolve(data);
          } else if (error) {
            reject(error);
          }
        });
      });
      return data;
    } catch (error) {
      console.error("Error in get Album Types:", error);
    }
  };

  getDecades = async () => {
    const {
      getListOfDecades,
      match: {
        params: { org: orgId },
      },
    } = this.props;
    try {
      const data = await new Promise((resolve, reject) => {
        getListOfDecades({ org_id: orgId }, (data, error) => {
          if (data) {
            resolve(data);
          } else if (error) {
            reject(error);
          }
        });
      });
      return data;
    } catch (error) {
      console.error("Error in invokeBulkEdit:", error);
    }
  };

  invokeBulkEdit = async (jobId, orgId) => {
    const { bulkEditInvoke } = this.props;
    try {
      const data = await new Promise((resolve, reject) => {
        bulkEditInvoke({ org_id: orgId, job_id: jobId }, (data, error) => {
          if (data) {
            this.setState({ trackIds: data.selected_tracks });
            this.setState({ albumIds: data.selected_albums });
            resolve(data);
          } else if (error) {
            reject(error);
          }
        });
      });
      return data;
    } catch (error) {
      console.error("Error in invokeBulkEdit:", error);
    }
  };

  handleTabChange = (event, newValue) => {

    var errors = this.trackValidationErrors([this.state.currentTrackId]);
    if (errors.length > 0) {
      this.handleErrorDialogOpen(errors.join(", "));
      return;
    }

    this.setState({
      currentTab: newValue,
    });

    if (newValue === bulkEditTypesENUM.ALBUM) {
      this.isCommonAlbumTrue();
    } else if (newValue === bulkEditTypesENUM.TRACK) {
      this.isCommonTrackTrue();
    } else if (newValue === bulkEditTypesENUM.TAGGING) {
      this.isCommonTaggingTrue();
    }
  };

  handleEditSingleTrackChange = (event) => {
    var errors = this.trackValidationErrors([this.state.currentTrackId]);
    if (errors.length > 0) {
      this.handleErrorDialogOpen(errors.join(", "));
      return;
    }

    this.handleTabChange(null, bulkEditTypesENUM.TRACK);

    const { currentTrackIndex, invokedBulkJob, currentTrackId } = this.state;
    this.setState({ editSingleTrack_bulkEdit: event.target.checked });
    if (!event.target.checked) {
      this.setState({ editTrackAppendValues: true });
      if (currentTrackIndex < invokedBulkJob.selected_tracks?.length) {
        const checkCurrentIndex =
          currentTrackIndex == -1 ? currentTrackIndex : currentTrackIndex - 1;
        // const nextIndex = currentTrackIndex + 1;
        const nextIndex = checkCurrentIndex + 1;
        this.setState({ currentTrackIndex: nextIndex });
        const currentId = invokedBulkJob.selected_tracks[nextIndex];
        this.setState({ currentTrackId: currentId });

        this.searchTrackById(currentId);
        this.editTrackAppendTrue(currentId);
      } else {
        this.searchTrackById(currentTrackId);
        this.editTrackAppendTrue(currentTrackId);
      }
    } else {
      this.isCommonTrackTrue();
    }
  };

  handleEditSingleAlbumChange = (event) => {
    this.setState({ editSingleAlbum_bulkEdit: event.target.checked });
    const { currentAlbumIndex, invokedBulkJob, currentAlbumId } = this.state;

    this.handleTabChange(null, bulkEditTypesENUM.ALBUM);

    if (!event.target.checked) {
      this.setState({ editAlbumAppendValues: true });
      if (currentAlbumIndex < invokedBulkJob?.selected_albums?.length) {
        const checkCurrentIndex =
          currentAlbumIndex == -1 ? currentAlbumIndex : currentAlbumIndex - 1;
        // const nextIndex = currentTrackIndex + 1;
        const nextIndex = checkCurrentIndex + 1;
        this.setState({ currentAlbumIndex: nextIndex });
        const currentId = invokedBulkJob.selected_albums[nextIndex];
        this.setState({ currentAlbumId: currentId });
        this.searchAlbumById(currentId);
        this.editAlbumAppendTrue(currentId);
      } else {
        this.searchAlbumById(currentAlbumId);
        this.editAlbumAppendTrue(currentAlbumId);
      }
    } else {
      this.isCommonAlbumTrue();
    }
  };

  handleAlbumAppendToggleChange = (event) => {
    this.setState({ editAlbumAppendValues: event.target.checked });
    const { editSingleAlbum_bulkEdit, currentAlbumId } = this.state;
    const {
      jobEditItems,
      bulkEditData: { job, albumEditing },
    } = this.props;

    let currentAlbumUpdates = { ...job.album_common_updates };
    let albumSpecificUpdates = { ...job.album_specific_updates };
    let currentSpecificAlbumUpdates =
      albumSpecificUpdates[currentAlbumId] || {};

    if (editSingleAlbum_bulkEdit) {
      if (event.target.checked) {
        currentAlbumUpdates[checkAlbumAppendValues.AlbumCommonAppend] =
          event.target.checked;

        let albumCommonAppendFields =
          currentAlbumUpdates.albumCommonAppendFields || [];

        if (currentAlbumUpdates) {
          const fieldsToCheck = [
            checkAlbumAppendValues.Company_Details,
            checkAlbumAppendValues.Librarian_Notes,
            checkAlbumAppendValues.Notes,
          ];

          fieldsToCheck.forEach((field) => {
            if (
              currentAlbumUpdates[field] &&
              !albumCommonAppendFields.includes(field)
            ) {
              albumCommonAppendFields.push(field);
            }
          });
        }
        currentAlbumUpdates["albumCommonAppendFields"] =
          albumCommonAppendFields;
        const updatedJob = {
          ...job,
          album_common_updates: currentAlbumUpdates,
        };
        jobEditItems(updatedJob);
      } else {
        currentAlbumUpdates[checkAlbumAppendValues.AlbumCommonAppend] =
          event.target.checked;
        currentAlbumUpdates.albumCommonAppendFields = [];
        const updatedJob = {
          ...job,
          album_common_updates: currentAlbumUpdates,
        };
        jobEditItems(updatedJob);
      }
    } else {
      currentSpecificAlbumUpdates[checkAlbumAppendValues.AlbumSpecificAppend] =
        event.target.checked;
      albumSpecificUpdates[currentAlbumId] = currentSpecificAlbumUpdates;
      const updatedJob = {
        ...job,
        album_specific_updates: albumSpecificUpdates,
      };

      jobEditItems(updatedJob);

      let jobDetails = job?.album_specific_updates
        ? [currentAlbumId] != null
          ? job.album_specific_updates[currentAlbumId]
          : null
        : null;

      this.setState({
        albumCompanyDetailsAppendFalse: jobDetails?.albumSpecificAppendFalse
          ?.org_sky_CompanyDetails
          ? jobDetails.albumSpecificAppendFalse.org_sky_CompanyDetails
          : albumEditing?.org_sky_CompanyDetails
            ? albumEditing.org_sky_CompanyDetails
            : "",

        albumLibrarianNotesAppendFalse: jobDetails?.albumSpecificAppendFalse
          ?.org_sky_LibrarianNotes
          ? jobDetails.albumSpecificAppendFalse.org_sky_LibrarianNotes
          : albumEditing?.org_sky_LibrarianNotes
            ? albumEditing.org_sky_LibrarianNotes
            : "",

        albumProdNotesAppendFalse: jobDetails?.albumSpecificAppendFalse
          ?.prodNotes
          ? jobDetails.albumSpecificAppendFalse.prodNotes
          : albumEditing?.prodNotes
            ? albumEditing.prodNotes
            : "",
      });
    }
  };

  handleTrackAppendToggleChange = (event) => {
    this.setState({ editTrackAppendValues: event.target.checked, dirty: true });

    const {
      jobEditItems,
      bulkEditData: { job, editing },
    } = this.props;
    const { editSingleTrack_bulkEdit, currentTrackId } = this.state;
    let currentTrackUpdates = { ...job.track_common_updates };
    let trackSpecificUpdates = { ...job.track_specific_updates };
    let currentSpecificTrackUpdates =
      trackSpecificUpdates[currentTrackId] || {};

    if (editSingleTrack_bulkEdit) {
      if (event.target.checked) {
        currentTrackUpdates[checkTrackAppendValues.TrackCommonAppend] =
          event.target.checked;

        let trackCommonAppendFields =
          currentTrackUpdates.trackCommonAppendFields || [];

        if (currentTrackUpdates) {
          // Check and push the required fields if they are not already present in trackCommonAppendFields
          const fieldsToCheck = [
            checkTrackAppendValues.Lyrics,
            checkTrackAppendValues.Librarian_Notes,
            checkTrackAppendValues.Notes,
          ];

          fieldsToCheck.forEach((field) => {
            if (
              currentTrackUpdates[field] &&
              !trackCommonAppendFields.includes(field)
            ) {
              trackCommonAppendFields.push(field);
            }
          });
        }

        currentTrackUpdates["trackCommonAppendFields"] =
          trackCommonAppendFields;
        const updatedJob = {
          ...job,
          track_common_updates: currentTrackUpdates,
        };
        jobEditItems(updatedJob);
      } else {
        currentTrackUpdates[checkTrackAppendValues.TrackCommonAppend] =
          event.target.checked;
        currentTrackUpdates.trackCommonAppendFields = [];
        const updatedJob = {
          ...job,
          track_common_updates: currentTrackUpdates,
        };
        jobEditItems(updatedJob);
      }
    } else {
      currentSpecificTrackUpdates[checkTrackAppendValues.TrackSpecificAppend] =
        event.target.checked;
      trackSpecificUpdates[currentTrackId] = currentSpecificTrackUpdates;
      const updatedJob = {
        ...job,
        track_specific_updates: trackSpecificUpdates,
      };
      jobEditItems(updatedJob);

      let jobDetails = job?.track_specific_updates
        ? [currentTrackId] != null
          ? job.track_specific_updates[currentTrackId]
          : null
        : null;

      this.setState({
        trackLyricsAppendFalse: jobDetails?.trackSpecificAppendFalse
          ?.org_sky_Lyrics
          ? jobDetails.trackSpecificAppendFalse.org_sky_Lyrics
          : editing?.org_sky_Lyrics
            ? editing.org_sky_Lyrics
            : "",

        trackLibrarianNotesAppendFalse: jobDetails?.trackSpecificAppendFalse
          ?.org_sky_LibrarianNotes
          ? jobDetails.trackSpecificAppendFalse.org_sky_LibrarianNotes
          : editing?.org_sky_LibrarianNotes
            ? editing.org_sky_LibrarianNotes
            : "",

        trackTrackNotesAppendFalse: jobDetails?.trackSpecificAppendFalse
          ?.trackNotes
          ? jobDetails.trackSpecificAppendFalse.trackNotes
          : editing?.trackNotes
            ? editing.trackNotes
            : "",
      });
    }
  };

  handleNext = () => {
    const {
      currentTrackIndex,
      currentAlbumIndex,
      trackIds,
      albumIds,
      currentTab,
    } = this.state;

    var errors = this.trackValidationErrors([this.state.currentTrackId]);
    if (errors.length > 0) {
      this.handleErrorDialogOpen(errors.join(", "));
      return;
    }

    if (currentTab == bulkEditTypesENUM.TRACK || currentTab == bulkEditTypesENUM.TAGGING) {
      if (currentTrackIndex < trackIds.length - 1) {
        const nextIndex = currentTrackIndex + 1;
        const currentId = trackIds[nextIndex];
        this.setState({ currentTrackId: currentId });
        this.editTrackAppendTrue(currentId);
        this.setState({ currentTrackIndex: nextIndex, currentId }, () => {
          this.searchTrackById(currentId);
        });
      }
    } else {
      if (currentAlbumIndex < albumIds.length - 1) {
        const nextIndex = currentAlbumIndex + 1;
        const currentId = albumIds[nextIndex];
        this.setState({ currentAlbumId: currentId });
        this.editAlbumAppendTrue(currentId);
        this.setState({ currentAlbumIndex: nextIndex, currentId }, () => {
          this.searchAlbumById(currentId);
        });
      }
    }
  };

  handlePrevious = () => {
    const {
      currentTrackIndex,
      currentAlbumIndex,
      trackIds,
      albumIds,
      currentTab,
    } = this.state;

    var errors = this.trackValidationErrors([this.state.currentTrackId]);
    if (errors.length > 0) {
      this.handleErrorDialogOpen(errors.join(", "));
      return;
    }

    if (currentTab == bulkEditTypesENUM.TRACK || currentTab == bulkEditTypesENUM.TAGGING) {
      if (currentTrackIndex > 0) {
        const previousIndex = currentTrackIndex - 1;
        const previousTrackId = trackIds[previousIndex];
        this.editTrackAppendTrue(previousTrackId);
        this.setState(
          { currentTrackIndex: previousIndex, currentTrackId: previousTrackId },
          () => {
            this.searchTrackById(previousTrackId);
          }
        );
      }
    } else {
      if (currentAlbumIndex > 0) {
        const previousAlbumIndex = currentAlbumIndex - 1;
        const previousAlbumId = albumIds[previousAlbumIndex];
        this.editAlbumAppendTrue(previousAlbumId);
        this.setState(
          {
            currentAlbumIndex: previousAlbumIndex,
            currentAlbumId: previousAlbumId,
          },
          () => {
            this.searchAlbumById(previousAlbumId);
          }
        );
      }
    }
  };

  trackTitleEmptyError = "Track title is empty, please provide a proper track title.";

  trackValidationErrors = (tracksIds) => {
    const {
      bulkEditData: { job: { track_specific_updates } },
    } = this.props;

    var errors = [];
    for (const currentTrackId of tracksIds || []) {
      if (track_specific_updates) {
        const trackUpdates = track_specific_updates[currentTrackId];
        if (trackUpdates && Object.keys(trackUpdates).length > 0 && trackUpdates.trackTitle != undefined && !(trackUpdates.trackTitle?.trim())) {
          if (!errors.includes(this.trackTitleEmptyError))
            errors.push(this.trackTitleEmptyError);
        }
      }
    }
    return errors;
  };

  searchTrackById = (currentTrackId) => {
    const {
      search,
      data: { query },
      match: {
        params: { type: bulkEditType, org: orgId },
      },
    } = this.props;

    if (bulkEditType == bulkEditStringTypes.TRACK) {
      search(
        {
          ...query,
          filters: [
            {
              value: [currentTrackId],
              operator: FilterOperatorTypes.equals,
              field: "id",
            },
          ],
          page: 0,
        },
        { orgId: orgId }
      );
    } else {
      search(
        {
          ...query,
          filters: [
            {
              value: [currentTrackId],
              operator: FilterOperatorTypes.equals,
              field: "prodId",
            },
          ],
          page: 0,
        },
        { orgId: orgId }
      );
    }
  };

  searchAlbumById = (currentAlbumId) => {
    const {
      albumSearch,
      data: { query },
      match: {
        params: { org: orgId },
      },
    } = this.props;

    albumSearch(
      {
        ...query,
        filters: [
          {
            operator: FilterOperatorTypes.equals,
            value: [currentAlbumId],
            field: "prodId",
          },
        ],
        page: 0,
        size: 1,
      },
      { orgId: orgId }
    );
  };

  handleKeywordChange = (trackId, keywords) => {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: null });
    }
    const {
      bulkEditData: { job, editing },
    } = this.props;

    var existingKeywords = editing.keywords || [];
    var keywordsTobeAdded = keywords.filter(k => !existingKeywords.includes(k.label));
    var keywordsTobeRemoved = existingKeywords.filter(k => !keywords.some(ka => ka.label?.trim()?.toLowerCase() == k?.trim()?.toLowerCase())).map(k => ({ type: 'keyword', label: k }));
    var taggingUpdates = (job.track_specific_updates?.[trackId]?.tagging_updates) || {};

    taggingUpdates = {
      ...taggingUpdates,
      keywords_add: keywordsTobeAdded,
      keywords_remove: keywordsTobeRemoved,
    };

    job.track_specific_updates = {
      ...(job.track_specific_updates || {}),
      [trackId]: {
        tagging_updates: taggingUpdates,
      },
    };

    this.setState({ dirty: true });
  };

  handleTrackValueChange = (event, maxLength) => {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: null });
    }
    const {
      jobEditItems,
      getValidationItems,
      setErrorMessage,
      bulkEditData: { job, validationErrors },
    } = this.props;

    const { currentTrackId, editTrackAppendValues } = this.state;
    this.setState({ dirty: true });
    let name = event?.target?.name;
    let value = event?.target?.value;
    let trackSpecificUpdates = { ...job.track_specific_updates };
    let currentTrackUpdates = {};
    let trackSpecificValidation = {};
    let trackSpecificAppendFalse = {};
    let trackSpecificAppendTrue = {};
    currentTrackUpdates = trackSpecificUpdates[currentTrackId] || {};

    if (editTrackAppendValues) {
      this.handleSingleTrackAppendValues(event.target);
    } else {
      this.handleSingleTrackAppendValuesFalse(event.target);
    }
    currentTrackUpdates[checkTrackAppendValues.TrackSpecificAppend] =
      editTrackAppendValues;

    currentTrackUpdates[name] = value;

    if (editTrackAppendValues) {
      let trackSpecificAppendFields =
        currentTrackUpdates.trackSpecificAppendFields || [];
      if (
        name === checkTrackAppendValues.Lyrics ||
        name === checkTrackAppendValues.Librarian_Notes ||
        name === checkTrackAppendValues.Notes
      ) {
        if (!trackSpecificAppendFields.includes(name)) {
          trackSpecificAppendFields.push(name);
        }
      }
      trackSpecificAppendTrue =
        currentTrackUpdates.trackSpecificAppendTrue || {};
      switch (name) {
        case checkTrackAppendValues.Lyrics:
        case checkTrackAppendValues.Librarian_Notes:
        case checkTrackAppendValues.Notes:
          trackSpecificAppendTrue[name] = value;
          break;
        default:
          break;
      }
      currentTrackUpdates.trackSpecificAppendTrue = trackSpecificAppendTrue;
      currentTrackUpdates["trackSpecificAppendFields"] =
        trackSpecificAppendFields;
    } else {
      trackSpecificAppendFalse =
        currentTrackUpdates.trackSpecificAppendFalse || {};
      switch (name) {
        case checkTrackAppendValues.Lyrics:
        case checkTrackAppendValues.Librarian_Notes:
        case checkTrackAppendValues.Notes:
          trackSpecificAppendFalse[name] = value;
          break;
        default:
          break;
      }
      currentTrackUpdates.trackSpecificAppendFalse = trackSpecificAppendFalse;
    }

    trackSpecificUpdates[currentTrackId] = currentTrackUpdates;
    const updatedJob = { ...job, track_specific_updates: trackSpecificUpdates };
    jobEditItems(updatedJob);

    let currentTrackValidation = {};
    let currentValidation = {};

    trackSpecificValidation = {
      ...validationErrors.track_specific_validation,
    };
    currentTrackValidation = trackSpecificValidation[currentTrackId] || {};

    if (value?.length >= maxLength && maxLength > 0) {
      setErrorMessage(`Maximum Length ${maxLength}`);
      currentTrackValidation[name] = `Maximum Length ${maxLength}`;
    } else if (name === "trackTitle" && !(value?.trim())) {
      setErrorMessage(`Track title can't be empty`);
      currentTrackValidation[name] = `Track title can't be empty`;
    } else if (currentTrackValidation[name]) {
      delete currentTrackValidation[name];
    }

    if (Object.keys(currentTrackValidation).length === 0) {
      delete trackSpecificValidation[currentTrackId];
    }
    else {
      trackSpecificValidation[currentTrackId] = currentTrackValidation;
    }

    currentValidation = {
      ...validationErrors,
      track_specific_validation: trackSpecificValidation,
    };

    getValidationItems(currentValidation);
  };

  handleTrackAddChip = (chip, name) => {
    const {
      jobEditItems,
      bulkEditData: { job, editing },
    } = this.props;
    this.setState({ dirty: true });

    const { currentTrackId } = this.state;
    this.setState({ dirty: true });
    let trackSpecificUpdates = { ...job.track_specific_updates };
    let currentTrackUpdates = trackSpecificUpdates[currentTrackId] || {};
    let updateChipValues = [];

    let previousValue = currentTrackUpdates?.[name];

    if (previousValue == undefined) {
      updateChipValues = [
        ...(editing?.[name] || []),
        ...(currentTrackUpdates?.[name] || []),
      ];
    } else {
      updateChipValues = [...(currentTrackUpdates?.[name] || [])];
    }

    let chipValues = chip?.split(/\s*[,/;]+\s*/).filter(Boolean);
    if (chipValues && chipValues.length > 0) {
      chipValues.forEach((word) => {
        if (!updateChipValues.includes(word)) {
          updateChipValues.push(word);
        }
      });
      currentTrackUpdates[name] = [
        ...new Set([...(currentTrackUpdates[name] || []), ...updateChipValues]),
      ];
    }

    trackSpecificUpdates[currentTrackId] = currentTrackUpdates;
    const updatedJob = {
      ...job,
      track_specific_updates: trackSpecificUpdates,
    };
    jobEditItems(updatedJob);
  };

  handleTrackDeleteChip = (chip, name) => {
    const {
      jobEditItems,
      bulkEditData: { job, editing },
    } = this.props;
    const { currentTrackId } = this.state;
    this.setState({ dirty: true });
    let trackSpecificUpdates = { ...job.track_specific_updates };
    let currentTrackUpdates = trackSpecificUpdates[currentTrackId] || {};
    let updateChipValues = currentTrackUpdates[name] || [];

    if (updateChipValues.length === 0) {
      updateChipValues = [...(editing?.[name] || [])];
    }

    updateChipValues = updateChipValues.filter((term) => term !== chip);
    currentTrackUpdates[name] = updateChipValues;
    trackSpecificUpdates[currentTrackId] = currentTrackUpdates;
    const updatedJob = {
      ...job,
      track_specific_updates: trackSpecificUpdates,
    };

    jobEditItems(updatedJob);
  };

  handleTrackCommonValueChange = (event, maxLength) => {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: null });
    }
    const {
      jobEditItems,
      bulkEditData: { job, validationErrors },
      setErrorMessage,
      getValidationItems,
    } = this.props;

    const { editTrackAppendValues } = this.state;

    if (editTrackAppendValues) {
      this.handleCommonTrackAppendValues(event.target);
    }
    let name = event.target?.name;
    let value = event.target?.value;
    this.setState({ dirty: true });

    let currentTrackUpdates = {};
    let currentValidation = {};
    let currentTrackValidation = {};
    currentTrackUpdates = { ...job.track_common_updates };
    currentTrackUpdates[name] = value;
    currentTrackUpdates[checkTrackAppendValues.TrackCommonAppend] =
      editTrackAppendValues;
    if (editTrackAppendValues) {
      let trackCommonAppendFields =
        currentTrackUpdates.trackCommonAppendFields || [];
      if (
        name === checkTrackAppendValues.Lyrics ||
        name === checkTrackAppendValues.Librarian_Notes ||
        name === checkTrackAppendValues.Notes
      ) {
        if (!trackCommonAppendFields.includes(name)) {
          trackCommonAppendFields.push(name);
        }
      }
      currentTrackUpdates["trackCommonAppendFields"] = trackCommonAppendFields;
    }
    const updatedJob = { ...job, track_common_updates: currentTrackUpdates };

    jobEditItems(updatedJob);

    if (value?.length >= maxLength && maxLength > 0) {
      setErrorMessage(`Maximum Length ${maxLength}`);
      currentTrackValidation = {
        ...validationErrors.track_common_validation,
      };
      currentTrackValidation[name] = `Maximum Length ${maxLength}`;
      currentValidation = {
        ...validationErrors,
        track_common_validation: currentTrackValidation,
      };
      getValidationItems(currentValidation);
    } else if (name === "trackTitle" && !(value?.trim())) {
      currentTrackValidation = {
        ...validationErrors.track_common_validation,
      };
      currentTrackValidation[name] = "Track title can't be empty";
      currentValidation = {
        ...validationErrors,
        track_common_validation: currentTrackValidation,
      };
      getValidationItems(currentValidation);
    } else {
      currentTrackValidation = { ...validationErrors.track_common_validation };
      if (currentTrackValidation[name]) {
        delete currentTrackValidation[name];
      }
      currentValidation = {
        ...validationErrors,
        track_common_validation: currentTrackValidation,
      };
      getValidationItems(currentValidation);
    }
  };

  handleTrackCommonAddChip = (chip, name) => {
    const {
      jobEditItems,
      bulkEditData: { job, trackCommonEditing },
    } = this.props;
    this.setState({ dirty: true });
    let currentTrackUpdates = {};
    currentTrackUpdates = { ...job.track_common_updates };
    let updateChipValues = [...(currentTrackUpdates?.[name] || [])];
    let chipValues = chip?.split(/\s*[,/;]+\s*/).filter(Boolean);
    if (chipValues && chipValues.length > 0) {
      chipValues.forEach((word) => {
        if (!updateChipValues.includes(word)) {
          updateChipValues.push(word);
        }
      });

      currentTrackUpdates[name] = [
        ...new Set([...(currentTrackUpdates[name] || []), ...updateChipValues]),
      ];
    }

    const updatedJob = { ...job, track_common_updates: currentTrackUpdates };
    jobEditItems(updatedJob);
  };

  handleTrackCommonDeleteChip = (chip, name) => {
    const {
      jobEditItems,
      bulkEditData: { job },
    } = this.props;
    this.setState({ dirty: true });

    let currentTrackUpdates = { ...job.track_common_updates };
    let updateChipValues = currentTrackUpdates[name] || [];
    updateChipValues = updateChipValues.filter((r) => r !== chip);
    currentTrackUpdates[name] = updateChipValues;

    const updatedJob = { ...job, track_common_updates: currentTrackUpdates };

    jobEditItems(updatedJob);
  };

  handleAlbumValuesChange = (event, maxLength) => {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: null });
    }
    const {
      jobEditItems,
      setErrorMessage,
      getValidationItems,
      bulkEditData: { job, validationErrors, listOfAlbumTypes },
    } = this.props;

    const { currentAlbumId, editAlbumAppendValues } = this.state;
    this.setState({ dirty: true });
    let name = event.target.name;
    let value = event.target.value;

    if (editAlbumAppendValues) {
      this.handleSingleAlbumAppendValues(event.target);
    } else {
      this.handleSingleAlbumAppendValuesFalse(event.target);
    }

    let albumSpecificUpdates = { ...job.album_specific_updates };
    let currentAlbumUpdates = {};
    let albumSpecificAppendFalse = {};
    let albumSpecificAppendTrue = {};
    currentAlbumUpdates = albumSpecificUpdates[currentAlbumId] || {};
    if (name === "org_sky_AlbumTypeID") {
      const albumType = listOfAlbumTypes.find((type) => type.value === value);
      if (albumType) {
        currentAlbumUpdates["org_sky_AlbumType"] = albumType.label;
      } else {
        currentAlbumUpdates["org_sky_AlbumType"] = "Unknown";
      }
    }
    currentAlbumUpdates[name] = value;
    currentAlbumUpdates[checkAlbumAppendValues.AlbumSpecificAppend] =
      editAlbumAppendValues;
    if (editAlbumAppendValues) {
      let albumSpecificAppendFields =
        currentAlbumUpdates.albumSpecificAppendFields || [];
      if (
        name === checkAlbumAppendValues.Company_Details ||
        name === checkAlbumAppendValues.Librarian_Notes ||
        name === checkAlbumAppendValues.Notes
      ) {
        if (!albumSpecificAppendFields.includes(name)) {
          albumSpecificAppendFields.push(name);
        }
      }
      albumSpecificAppendTrue =
        currentAlbumUpdates.albumSpecificAppendTrue || {};
      switch (name) {
        case checkAlbumAppendValues.Company_Details:
        case checkAlbumAppendValues.Librarian_Notes:
        case checkAlbumAppendValues.Notes:
          albumSpecificAppendTrue[name] = value;
          break;
        default:
          break;
      }
      currentAlbumUpdates.albumSpecificAppendTrue = albumSpecificAppendTrue;
      currentAlbumUpdates["albumSpecificAppendFields"] =
        albumSpecificAppendFields;
    } else {
      albumSpecificAppendFalse =
        currentAlbumUpdates.albumSpecificAppendFalse || {};
      switch (name) {
        case checkAlbumAppendValues.Company_Details:
        case checkAlbumAppendValues.Librarian_Notes:
        case checkAlbumAppendValues.Notes:
          albumSpecificAppendFalse[name] = value;
          break;
        default:
          break;
      }
      currentAlbumUpdates.albumSpecificAppendFalse = albumSpecificAppendFalse;
    }
    albumSpecificUpdates[currentAlbumId] = currentAlbumUpdates;
    const updatedJob = { ...job, album_specific_updates: albumSpecificUpdates };
    jobEditItems(updatedJob);

    let currentAlbumValidation = {};
    let currentValidation = {};
    let albumSpecificValidation = {
      ...validationErrors.album_specific_validation,
    };

    if (value?.length >= maxLength && maxLength > 0) {
      setErrorMessage(`Maximum Length ${maxLength}`);
      currentAlbumValidation = albumSpecificValidation[currentAlbumId] || {};
      currentAlbumValidation[name] = `Maximum Length ${maxLength}`;
      albumSpecificValidation[currentAlbumId] = currentAlbumValidation;

      currentValidation = {
        ...validationErrors,
        album_specific_validation: albumSpecificValidation,
      };
    }
    else if (name === "prodName" && !(value?.trim())) {
      setErrorMessage(`Album Title Can't be Empty`);
      currentAlbumValidation = albumSpecificValidation[currentAlbumId] || {};
      currentAlbumValidation[name] = `Album Title Can't be Empty`;
      albumSpecificValidation[currentAlbumId] = currentAlbumValidation;

      currentValidation = {
        ...validationErrors,
        album_specific_validation: albumSpecificValidation,
      };
    }
    else if (currentAlbumValidation[name]) {
      delete albumSpecificValidation[currentAlbumId][name];

      currentValidation = {
        ...validationErrors,
        album_specific_validation: albumSpecificValidation,
      };
    }

    getValidationItems(currentValidation);

    clearTimeout(this.timeoutId);
  };

  handleAlbumAddChip = (chip, name) => {
    const {
      jobEditItems,
      bulkEditData: { job, albumEditing },
    } = this.props;
    this.setState({ dirty: true });
    const { currentAlbumId } = this.state;

    let albumSpecificUpdates = { ...job.album_specific_updates };
    let currentAlbumUpdates = albumSpecificUpdates[currentAlbumId] || {};
    let updateChipValues = [];
    let previousValue = currentAlbumUpdates?.[name];
    if (previousValue == undefined) {
      updateChipValues = [
        ...(albumEditing?.[name] || []),
        ...(currentAlbumUpdates?.[name] || []),
      ];
    } else {
      updateChipValues = [...(currentAlbumUpdates?.[name] || [])];
    }

    let chipValues = chip?.split(/\s*[,/;]+\s*/).filter(Boolean);
    if (chipValues && chipValues.length > 0) {
      chipValues.forEach((word) => {
        if (!updateChipValues.includes(word)) {
          updateChipValues.push(word);
        }
      });

      currentAlbumUpdates[name] = [
        ...new Set([...(currentAlbumUpdates[name] || []), ...updateChipValues]),
      ];
    }

    albumSpecificUpdates[currentAlbumId] = currentAlbumUpdates;
    const updatedJob = {
      ...job,
      album_specific_updates: albumSpecificUpdates,
    };
    jobEditItems(updatedJob);
  };

  handleAlbumDeleteChip = (chip, name) => {
    const {
      jobEditItems,
      bulkEditData: { job, albumEditing },
    } = this.props;
    const { currentAlbumId } = this.state;

    this.setState({ dirty: true });
    let albumSpecificUpdates = { ...job.album_specific_updates };
    let currentAlbumUpdates = albumSpecificUpdates[currentAlbumId] || {};
    let updateChipValues = currentAlbumUpdates[name] || [];
    if (updateChipValues.length === 0) {
      updateChipValues = [...(albumEditing?.[name] || [])];
    }
    updateChipValues = updateChipValues.filter((term) => term !== chip);
    currentAlbumUpdates[name] = updateChipValues;
    albumSpecificUpdates[currentAlbumId] = currentAlbumUpdates;
    const updatedJob = {
      ...job,
      album_specific_updates: albumSpecificUpdates,
    };
    jobEditItems(updatedJob);
  };

  handleAlbumCommonValueChange = (event, maxLength) => {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: null });
    }
    const {
      jobEditItems,
      bulkEditData: { job, validationErrors },
      setErrorMessage,
      getValidationItems,
    } = this.props;

    const { editAlbumAppendValues } = this.state;

    if (editAlbumAppendValues) {
      this.handleCommonAlbumAppendValues(event.target);
    }

    this.setState({ dirty: true });
    let name = event.target.name;
    let value = event.target.value;
    let currentAlbumUpdates = {};
    let currentAlbumValidation = {};
    let currentValidation = {};
    currentAlbumUpdates = { ...job.album_common_updates };
    currentAlbumUpdates[name] = value;
    currentAlbumUpdates[checkAlbumAppendValues.AlbumCommonAppend] =
      editAlbumAppendValues;
    if (editAlbumAppendValues) {
      let albumCommonAppendFields =
        currentAlbumUpdates.albumCommonAppendFields || [];
      if (
        name === checkAlbumAppendValues.Company_Details ||
        name === checkAlbumAppendValues.Librarian_Notes ||
        name === checkAlbumAppendValues.Notes
      ) {
        if (!albumCommonAppendFields.includes(name)) {
          albumCommonAppendFields.push(name);
        }
      }
      currentAlbumUpdates["albumCommonAppendFields"] = albumCommonAppendFields;
    }
    const updatedJob = { ...job, album_common_updates: currentAlbumUpdates };

    jobEditItems(updatedJob);

    if (value?.length >= maxLength) {
      if (maxLength > 0) {
        setErrorMessage(`Maximum Length ${maxLength}`);
        currentAlbumValidation = {
          ...validationErrors.album_common_validation,
        };
        currentAlbumValidation[name] = `Maximum Length ${maxLength}`;
        currentValidation = {
          ...validationErrors,
          album_common_validation: currentAlbumValidation,
        };
        getValidationItems(currentValidation);
      }
    } else {
      currentAlbumValidation = { ...validationErrors.album_common_validation };
      if (currentAlbumValidation[name]) {
        delete currentAlbumValidation[name];
      }
      currentValidation = {
        ...validationErrors,
        album_common_validation: currentAlbumValidation,
      };
      getValidationItems(currentValidation);
    }
  };

  handleCommonAlbumAddChip = (chip, name) => {
    const {
      jobEditItems,
      bulkEditData: { job },
    } = this.props;
    this.setState({ dirty: true });
    let currentAlbumUpdates = { ...job.album_common_updates };
    let updateChipValues = [...(currentAlbumUpdates?.[name] || [])];
    let chipValues = chip?.split(/\s*[,/;]+\s*/).filter(Boolean);
    if (chipValues && chipValues.length > 0) {
      chipValues.forEach((value) => {
        if (!updateChipValues.includes(value)) {
          updateChipValues.push(value);
        }
      });

      currentAlbumUpdates[name] = [
        ...new Set([...(currentAlbumUpdates[name] || []), ...updateChipValues]),
      ];
    }

    const updatedJob = { ...job, album_common_updates: currentAlbumUpdates };
    jobEditItems(updatedJob);
  };

  handleCommonAlbumDeleteChip = (chip, name) => {
    const {
      jobEditItems,
      bulkEditData: { job },
    } = this.props;
    this.setState({ dirty: true });

    let currentTrackUpdates = { ...job.track_common_updates };
    let updateChipValues = currentTrackUpdates[name] || [];
    updateChipValues = updateChipValues.filter((r) => r !== chip);
    currentTrackUpdates[name] = updateChipValues;

    const updatedJob = { ...job, track_common_updates: currentTrackUpdates };

    jobEditItems(updatedJob);
  };

  editAlbumAppendTrue = (id) => {
    const {
      bulkEditData: { job, albumEditing },
    } = this.props;
    let jobDetails = null;

    if (id) {
      jobDetails = job?.album_specific_updates
        ? [id] != null
          ? job.album_specific_updates[id]
          : null
        : null;
    }

    if (jobDetails) {
      this.setState({
        editAlbumAppendValues: jobDetails.albumSpecificAppend,
      });
    } else {
      this.setState({ editAlbumAppendValues: true });
    }
    this.setState({
      companyDetails: jobDetails?.albumSpecificAppendTrue
        ?.org_sky_CompanyDetails
        ? jobDetails.albumSpecificAppendTrue.org_sky_CompanyDetails
        : "",
    });
    this.setState({
      librarianNotes: jobDetails?.albumSpecificAppendTrue
        ?.org_sky_LibrarianNotes
        ? jobDetails.albumSpecificAppendTrue.org_sky_LibrarianNotes
        : "",
    });
    this.setState({
      prodNotes: jobDetails?.albumSpecificAppendTrue?.prodNotes
        ? jobDetails.albumSpecificAppendTrue.prodNotes
        : "",
    });
    this.setState({
      albumCompanyDetailsAppendFalse: jobDetails?.albumSpecificAppendFalse
        ?.org_sky_CompanyDetails
        ? jobDetails.albumSpecificAppendFalse.org_sky_CompanyDetails
        : albumEditing?.org_sky_CompanyDetails
          ? albumEditing.org_sky_CompanyDetails
          : "",
    });
    this.setState({
      albumLibrarianNotesAppendFalse: jobDetails?.albumSpecificAppendFalse
        ?.org_sky_LibrarianNotes
        ? jobDetails.albumSpecificAppendFalse.org_sky_LibrarianNotes
        : albumEditing?.org_sky_LibrarianNotes
          ? albumEditing.org_sky_LibrarianNotes
          : "",
    });
    this.setState({
      albumProdNotesAppendFalse: jobDetails?.albumSpecificAppendFalse?.prodNotes
        ? jobDetails.albumSpecificAppendFalse.prodNotes
        : albumEditing?.prodNotes
          ? albumEditing.prodNotes
          : "",
    });
  };

  editTrackAppendTrue = (id) => {
    const {
      bulkEditData: { job, editing },
    } = this.props;
    let jobDetails = null;
    if (id) {
      jobDetails = job?.track_specific_updates
        ? [id] != null
          ? job.track_specific_updates[id]
          : null
        : null;
    }
    if (jobDetails) {
      this.setState({ editTrackAppendValues: jobDetails.trackSpecificAppend });
    } else {
      this.setState({ editTrackAppendValues: true });
    }
    this.setState({
      trackLyrics: jobDetails?.trackSpecificAppendTrue?.org_sky_Lyrics
        ? jobDetails.trackSpecificAppendTrue.org_sky_Lyrics
        : "",
    });
    this.setState({
      trackLibrarianNotes: jobDetails?.trackSpecificAppendTrue
        ?.org_sky_LibrarianNotes
        ? jobDetails.trackSpecificAppendTrue.org_sky_LibrarianNotes
        : "",
    });
    this.setState({
      trackTrackNotes: jobDetails?.trackSpecificAppendTrue?.trackNotes
        ? jobDetails.trackSpecificAppendTrue.trackNotes
        : "",
    });
    this.setState({
      trackLyricsAppendFalse: jobDetails?.trackSpecificAppendFalse
        ?.org_sky_Lyrics
        ? jobDetails.trackSpecificAppendFalse.org_sky_Lyrics
        : editing?.org_sky_Lyrics
          ? editing.org_sky_Lyrics
          : "",
    });
    this.setState({
      trackLibrarianNotesAppendFalse: jobDetails?.trackSpecificAppendFalse
        ?.org_sky_LibrarianNotes
        ? jobDetails.trackSpecificAppendFalse.org_sky_LibrarianNotes
        : editing?.org_sky_LibrarianNotes
          ? editing.org_sky_LibrarianNotes
          : "",
    });
    this.setState({
      trackTrackNotesAppendFalse: jobDetails?.trackSpecificAppendFalse
        ?.trackNotes
        ? jobDetails.trackSpecificAppendFalse.trackNotes
        : editing?.trackNotes
          ? editing.trackNotes
          : "",
    });
  };

  isCommonAlbumTrue = () => {
    const {
      bulkEditData: { job },
    } = this.props;
    let jobDetails = job.album_common_updates;

    if (jobDetails) {
      this.setState({
        editAlbumAppendValues: jobDetails.albumCommonAppend,
      });
    } else {
      this.setState({ editAlbumAppendValues: true });
    }

    this.setState({
      commonCompanyDetails: jobDetails?.org_sky_CompanyDetails
        ? jobDetails.org_sky_CompanyDetails
        : "",
    });
    this.setState({
      commonLibrarianNotes: jobDetails?.org_sky_LibrarianNotes
        ? jobDetails.org_sky_LibrarianNotes
        : "",
    });
    this.setState({
      commonProdNotes: jobDetails?.prodNotes ? jobDetails.prodNotes : "",
    });
  };

  isCommonTrackTrue = () => {
    const {
      bulkEditData: { job },
    } = this.props;
    let jobDetails = job.track_common_updates;
    if (jobDetails) {
      this.setState({ editTrackAppendValues: jobDetails.trackCommonAppend });
    } else {
      this.setState({ editTrackAppendValues: true });
    }

    this.setState({
      commonTrackLyrics: jobDetails?.org_sky_Lyrics
        ? jobDetails.org_sky_Lyrics
        : "",
    });
    this.setState({
      commonTrackLibrarianNotes: jobDetails?.org_sky_LibrarianNotes
        ? jobDetails.org_sky_LibrarianNotes
        : "",
    });
    this.setState({
      commonTrackNotes: jobDetails?.trackTrackNotes
        ? jobDetails.trackTrackNotes
        : "",
    });
  };

  isCommonTaggingTrue = () => {
    // const {
    //   bulkEditData: { job },
    // } = this.props;
    // let jobDetails = job.track_common_updates;
    // if (jobDetails) {
    //   this.setState({ editTrackAppendValues: jobDetails.trackCommonAppend });
    // } else {
    //   this.setState({ editTrackAppendValues: true });
    // }

    // this.setState({
    //   commonTrackLyrics: jobDetails?.org_sky_Lyrics
    //     ? jobDetails.org_sky_Lyrics
    //     : "",
    // });
    // this.setState({
    //   commonTrackLibrarianNotes: jobDetails?.org_sky_LibrarianNotes
    //     ? jobDetails.org_sky_LibrarianNotes
    //     : "",
    // });
    // this.setState({
    //   commonTrackNotes: jobDetails?.trackTrackNotes
    //     ? jobDetails.trackTrackNotes
    //     : "",
    // });
    this.fetchTracks();
    this.fetchKeywords("", 20);
  };

  handleSingleAlbumAppendValues(value) {
    this.setState({ dirty: true });
    switch (value.name) {
      case checkAlbumAppendValues.Notes:
        this.setState({ prodNotes: value.value });
        break;
      case checkAlbumAppendValues.Librarian_Notes:
        this.setState({ librarianNotes: value.value });
        break;
      case checkAlbumAppendValues.Company_Details:
        this.setState({ companyDetails: value.value });
        break;
      default:
    }
  }

  handleCommonAlbumAppendValues(value) {
    this.setState({ dirty: true });
    switch (value.name) {
      case checkAlbumAppendValues.Notes:
        this.setState({ commonProdNotes: value.value });
        break;
      case checkAlbumAppendValues.Librarian_Notes:
        this.setState({ commonLibrarianNotes: value.value });
        break;
      case checkAlbumAppendValues.Company_Details:
        this.setState({ commonCompanyDetails: value.value });
        break;
      default:
    }
  }

  handleSingleAlbumAppendValuesFalse(value) {
    this.setState({ dirty: true });
    switch (value.name) {
      case checkAlbumAppendValues.Notes:
        this.setState({ albumProdNotesAppendFalse: value.value });
        break;
      case checkAlbumAppendValues.Librarian_Notes:
        this.setState({ albumLibrarianNotesAppendFalse: value.value });
        break;
      case checkAlbumAppendValues.Company_Details:
        this.setState({ albumCompanyDetailsAppendFalse: value.value });
        break;
      default:
    }
  }

  handleSingleTrackAppendValues(value) {
    this.setState({ dirty: true });
    switch (value.name) {
      case checkTrackAppendValues.Notes:
        this.setState({ trackTrackNotes: value.value });
        break;
      case checkTrackAppendValues.Librarian_Notes:
        this.setState({ trackLibrarianNotes: value.value });
        break;
      case checkTrackAppendValues.Lyrics:
        this.setState({ trackLyrics: value.value });
        break;
      default:
    }
  }

  handleSingleTrackAppendValuesFalse(value) {
    this.setState({ dirty: true });
    switch (value.name) {
      case checkTrackAppendValues.Notes:
        this.setState({ trackTrackNotesAppendFalse: value.value });
        break;
      case checkTrackAppendValues.Librarian_Notes:
        this.setState({ trackLibrarianNotesAppendFalse: value.value });
        break;
      case checkTrackAppendValues.Lyrics:
        this.setState({ trackLyricsAppendFalse: value.value });
        break;
      default:
    }
  }

  handleCommonTrackAppendValues(value) {
    this.setState({ dirty: true });
    switch (value.name) {
      case checkTrackAppendValues.Notes:
        this.setState({ commonTrackNotes: value.value });
        break;
      case checkTrackAppendValues.Librarian_Notes:
        this.setState({ commonTrackLibrarianNotes: value.value });
        break;
      case checkTrackAppendValues.Lyrics:
        this.setState({ commonTrackLyrics: value.value });
        break;
      default:
    }
  }

  refreshSingleAlbumAppendValues(name) {
    this.setState({ dirty: true });
    switch (name) {
      case checkAlbumAppendValues.Notes:
        this.setState({ prodNotes: null });
        break;
      case checkAlbumAppendValues.Librarian_Notes:
        this.setState({ librarianNotes: null });
        break;
      case checkAlbumAppendValues.Company_Details:
        this.setState({ companyDetails: null });
        break;
      default:
    }
  }

  refreshSingleTrackAppendValues(name) {
    this.setState({ dirty: true });
    switch (name) {
      case checkTrackAppendValues.Notes:
        this.setState({ trackTrackNotes: null });
        break;
      case checkTrackAppendValues.Librarian_Notes:
        this.setState({ trackLibrarianNotes: null });
        break;
      case checkTrackAppendValues.Lyrics:
        this.setState({ trackLyrics: null });
        break;
      default:
    }
  }

  handleAlbumRefreshValues = (name) => {
    const {
      albumEditItem,
      jobEditItems,
      getValidationItems,
      bulkEditData: { albumEditing, job, validationErrors },
    } = this.props;
    this.setState({ dirty: true });
    const { currentAlbumId, editAlbumAppendValues } = this.state;

    let albumSpecificUpdates = { ...job.album_specific_updates };
    let currentAlbumUpdates = {};
    let albumRefreshValue = albumEditing[name] ? albumEditing[name] : null;

    currentAlbumUpdates = albumSpecificUpdates[currentAlbumId] || {};
    currentAlbumUpdates[name] = albumRefreshValue;
    albumSpecificUpdates[currentAlbumId] = currentAlbumUpdates;
    const updatedJob = { ...job, album_specific_updates: albumSpecificUpdates };
    const newRefreshValue = {
      ...albumEditing,
      [name]: albumRefreshValue,
    };
    if (editAlbumAppendValues) {
      this.refreshSingleAlbumAppendValues(name);
    }

    jobEditItems(updatedJob);
    albumEditItem(newRefreshValue);

    let currentAlbumValidation = {};
    let albumSpecificValidation = {
      ...validationErrors.album_specific_validation,
    };

    currentAlbumValidation = albumSpecificValidation[currentAlbumId] || {};
    if (currentAlbumValidation[name]) {
      delete currentAlbumValidation[name];
    }
    albumSpecificValidation[currentAlbumId] = currentAlbumValidation;
    const currentValidation = {
      ...validationErrors,
      album_specific_validation: albumSpecificValidation,
    };
    getValidationItems(currentValidation);

    clearTimeout(this.timeoutId);

    this.timeoutId = setTimeout(() => {
      this.handleValuesChangeUpdate();
    }, 1500);
  };

  handleTrackRefreshValues = (name) => {
    const {
      editItem,
      jobEditItems,
      getValidationItems,

      bulkEditData: { editing, validationErrors, job },
    } = this.props;
    this.setState({ dirty: true });
    const { currentTrackId, editTrackAppendValues } = this.state;

    let trackSpecificUpdates = { ...job.track_specific_updates };
    let currentTrackUpdates = {};
    let refreshValue = editing[name] ? editing[name] : null;

    currentTrackUpdates = trackSpecificUpdates[currentTrackId] || {};
    currentTrackUpdates[name] = refreshValue;
    trackSpecificUpdates[currentTrackId] = currentTrackUpdates;
    const updatedJob = { ...job, track_specific_updates: trackSpecificUpdates };
    const newRefreshValue = {
      ...editing,
      [name]: refreshValue,
    };
    if (editTrackAppendValues) {
      this.refreshSingleTrackAppendValues(name);
    }
    jobEditItems(updatedJob);
    editItem(newRefreshValue);

    let currentTrackValidation = {};
    let trackSpecificValidation = {
      ...validationErrors.track_specific_validation,
    };

    currentTrackValidation = trackSpecificValidation[currentTrackId] || {};
    if (currentTrackValidation[name]) {
      delete currentTrackValidation[name];
    }
    trackSpecificValidation[currentTrackId] = currentTrackValidation;
    const currentValidation = {
      ...validationErrors,
      track_specific_validation: trackSpecificValidation,
    };
    getValidationItems(currentValidation);
  };

  handleCommonTrackRefreshValues = (name) => {
    const {
      commonEditItem,
      jobEditItems,
      getValidationItems,
      bulkEditData: { trackCommonEditing, job, validationErrors },
    } = this.props;
    this.setState({ dirty: true });
    const { editTrackAppendValues } = this.state;

    let currentTrackUpdates = {};
    currentTrackUpdates = { ...job.track_common_updates };
    currentTrackUpdates[name] = trackCommonEditing[name];
    currentTrackUpdates[checkTrackAppendValues.TrackCommonAppend] =
      editTrackAppendValues;
    const updatedJob = { ...job, track_common_updates: currentTrackUpdates };

    const newTrackCommonEditing = {
      ...trackCommonEditing,
      [name]: null,
    };

    jobEditItems(updatedJob);
    commonEditItem(newTrackCommonEditing);

    let currentTrackWarningClear = {};
    currentTrackWarningClear = { ...validationErrors.track_common_validation };

    if (currentTrackWarningClear[name]) {
      delete currentTrackWarningClear[name];
    }
    const updateWarning = {
      ...validationErrors,
      track_common_validation: currentTrackWarningClear,
    };
    getValidationItems(updateWarning);
  };

  handleCommonAlbumRefreshValues = (name) => {
    const {
      albumCommonEditItem,
      getValidationItems,
      jobEditItems,
      bulkEditData: { albumCommonEditing, job, validationErrors },
    } = this.props;
    this.setState({ dirty: true });
    const { editAlbumAppendValues } = this.state;
    let currentAlbumUpdates = {};
    currentAlbumUpdates = { ...job.album_common_updates };
    currentAlbumUpdates[name] = albumCommonEditing[name];
    currentAlbumUpdates[checkAlbumAppendValues.AlbumCommonAppend] =
      editAlbumAppendValues;

    const updatedJob = { ...job, album_common_updates: currentAlbumUpdates };

    const newAlbumCommonEditing = {
      ...albumCommonEditing,
      [name]: null,
    };

    jobEditItems(updatedJob);
    albumCommonEditItem(newAlbumCommonEditing);
    let currentAlbumValidation = {};
    currentAlbumValidation = { ...validationErrors.album_common_validation };
    if (currentAlbumValidation[name]) {
      delete currentAlbumValidation[name];
    }
    const currentValidation = {
      ...validationErrors,
      album_common_validation: currentAlbumValidation,
    };
    getValidationItems(currentValidation);

    clearTimeout(this.timeoutId);

    this.timeoutId = setTimeout(() => {
      this.handleValuesChangeUpdate();
    }, 1500);
  };

  handleValuesChangeUpdate = async () => {
    const {
      bulkEditSave,
      bulkEditData: { job },
      match: {
        params: { handle: jobId, org: orgId },
      },
    } = this.props;

    var errors = this.trackValidationErrors(job.selected_tracks);
    if (errors.length > 0) {
      this.handleErrorDialogOpen(errors.join(", "));
      return;
    }

    try {
      const data = await new Promise((resolve, reject) => {
        bulkEditSave(
          { job: job, org_id: orgId, job_id: jobId, valuesChange: true },

          (data, error) => {
            if (data) {
              this.setState({ trackIds: data.selected_tracks, dirty: false });
              resolve(data);
            } else if (error) {
              reject(error);
            }
          }
        );
      });
      return data;
    } catch (error) {
      console.error("Error in bulkEditSave:", error);
    }
  };

  handleSaveUpdateData = async () => {
    const {
      bulkEditSave,
      bulkEditData: { job },
      match: {
        params: { handle: jobId, org: orgId },
      },
    } = this.props;

    if (job?.track_specific_updates) {
      job.selected_tracks.forEach((trackId) => {
        const trackData = job.track_specific_updates[trackId];
        let appendTrue = trackData?.trackSpecificAppendTrue;
        let appendFalse = trackData?.trackSpecificAppendFalse;
        if (trackData) {
          if (trackData.trackSpecificAppend) {
            if (appendTrue != null) {
              if (appendTrue.org_sky_Lyrics != null) {
                trackData.org_sky_Lyrics = appendTrue?.org_sky_Lyrics;
              }
              if (appendTrue.org_sky_LibrarianNotes != null) {
                trackData.org_sky_LibrarianNotes =
                  appendTrue?.org_sky_LibrarianNotes;
              }
              if (appendTrue.trackNotes != null) {
                trackData.trackNotes = appendTrue?.trackNotes;
              }
            }
          } else {
            if (appendFalse != null) {
              if (appendFalse?.org_sky_Lyrics != null) {
                trackData.org_sky_Lyrics = appendFalse?.org_sky_Lyrics;
              }
              if (appendFalse?.org_sky_LibrarianNotes != null) {
                trackData.org_sky_LibrarianNotes =
                  appendFalse?.org_sky_LibrarianNotes;
              }
              if (appendFalse?.trackNotes != null) {
                trackData.trackNotes = appendFalse?.trackNotes;
              }
            }
          }
        }
      });
    }
    if (job?.album_specific_updates) {
      job.selected_albums.forEach((albumId) => {
        const albumData = job.album_specific_updates[albumId];
        let appendTrue = albumData?.albumSpecificAppendTrue;
        let appendFalse = albumData?.albumSpecificAppendFalse;
        if (albumData) {
          if (albumData.albumSpecificAppend) {
            if (appendTrue) {
              if (appendTrue?.org_sky_CompanyDetails != null) {
                albumData.org_sky_CompanyDetails =
                  appendTrue?.org_sky_CompanyDetails;
              }
              if (appendTrue?.org_sky_LibrarianNotes != null) {
                albumData.org_sky_LibrarianNotes =
                  appendTrue?.org_sky_LibrarianNotes;
              }
              if (appendTrue?.prodNotes != null) {
                albumData.prodNotes = appendTrue?.prodNotes;
              }
            }
          } else {
            if (appendFalse) {
              if (appendFalse?.org_sky_CompanyDetails != null) {
                albumData.org_sky_CompanyDetails =
                  appendFalse?.org_sky_CompanyDetails;
              }
              if (appendFalse?.org_sky_LibrarianNotes != null) {
                albumData.org_sky_LibrarianNotes =
                  appendFalse?.org_sky_LibrarianNotes;
              }
              if (appendFalse?.prodNotes != null) {
                albumData.prodNotes = appendFalse?.prodNotes;
              }
            }
          }
        }
      });
    }

    var errors = this.trackValidationErrors(job.selected_tracks);
    if (errors.length > 0) {
      this.handleErrorDialogOpen(errors.join(", "));
      return;
    }

    try {
      const data = await new Promise((resolve, reject) => {
        bulkEditSave(
          { job: job, org_id: orgId, job_id: jobId, valuesChange: false },
          (data, error) => {
            if (data) {
              this.setState({ trackIds: data.selected_tracks, messageOpen: true, dirty: false });
              resolve(data);
            } else if (error) {
              reject(error);
            }
          }
        );
      });

      return data;
    } catch (error) {
      console.error("Error in bulkEditSave:", error);
    }
  };

  handleEditPicture = () => {
    const fileInput = document.getElementById("imageInput");
    fileInput.click();
  };

  onDrop = (event) => {
    const {
      showAutoMessage,
      jobEditItems,
      match: {
        params: { handle: jobId, org: orgId },
      },
      bulkEditData: {
        job,
        validationErrors,
        posting: { busy, errors },
      },
    } = this.props;

    const { currentAlbumId } = this.state;
    const id = uuidv4();
    if (event.target.files.length > 0) {
      var file = event.target.files[0];
      if (file.size > 1000000) {
        showAutoMessage("File size must be less than 1MB!");
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        showAutoMessage("File type must be JPEG or PNG");
      } else {
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64data = reader.result;
          const imageTypeMatch = base64data.match(
            /^data:image\/(png|jpeg|gif);base64,/
          );
          if (!imageTypeMatch) {
            console.error("Invalid image data");
            return;
          }
          const imageType =
            imageTypeMatch[1] === "jpeg" ? "jpg" : imageTypeMatch[1];

          const image = await this.UploadImage(base64data, id, imageType);
          let albumSpecificUpdates = { ...job.album_specific_updates };
          let currentAlbumUpdates = {};
          currentAlbumUpdates = albumSpecificUpdates[currentAlbumId] || {};
          if (busy != true && errors == null) {
            currentAlbumUpdates["prodArtworkUrl"] =
              image && image?.url ? image.url : null;
            albumSpecificUpdates[currentAlbumId] = currentAlbumUpdates;
            const updatedJob = {
              ...job,
              album_specific_updates: albumSpecificUpdates,
            };
            jobEditItems(updatedJob);
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  UploadImage = async (base64data, id, imageType) => {
    const {
      bulkEditUploadImage,
      bulkEditData: { job },
      match: {
        params: { handle: jobId, org: orgId },
      },
    } = this.props;
    try {
      const data = await new Promise((resolve, reject) => {
        bulkEditUploadImage(base64data, id, imageType, orgId, (data, error) => {
          if (data) {
            resolve(data);
          } else if (error) {
            reject(error);
          }
        });
      });
      return data;
    } catch (error) {
      console.error("Error in invokeBulkEdit:", error);
    }
  };

  handleRemoveImage = () => {
    const {
      jobEditItems,
      bulkEditData: { job },
    } = this.props;
    const { currentAlbumId } = this.state;
    let albumSpecificUpdates = { ...job.album_specific_updates };
    let currentAlbumUpdates = albumSpecificUpdates[currentAlbumId] || {};
    currentAlbumUpdates["prodArtworkUrl"] = null;
    albumSpecificUpdates[currentAlbumId] = currentAlbumUpdates;
    const updatedJob = {
      ...job,
      album_specific_updates: albumSpecificUpdates,
    };
    jobEditItems(updatedJob);
  };

  handleBulkEditUpload = async () => {
    const {
      match: {
        params: { handle: jobId, org: orgId },
      },
      bulkEditPublish,
      bulkEditData: { loading },
    } = this.props;

    try {
      const responseData = await bulkEditPublish(
        `Publishing bulk edit in progress...`,
        jobId,
        orgId
      );
      if (responseData) {
        this.setState({ messageOpen: false });
      }
      if (!loading) {
        this.setState({ messageOpen: false });
      }
    } catch (error) {
      console.error("An error occurred during bulk edit publishing:", error);
    }
  };

  handleErrorDialogOpen = (message) => {
    this.setState({ errorDialogOpen: true, errorDialogMessage: message });
  }

  handleCloseErrorDialog = () => {
    this.setState({ errorDialogOpen: false, errorDialogMessage: "" });
  }

  handleOpenDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  handleSaveSession = () => {
    const {
      bulkEditData: { job },
      setErrorMessage,
    } = this.props;
    if (job.session_name.trim() !== "") {
      this.handleValuesChangeUpdate();
      this.setState({ isDialogOpen: false });
      this.setState({ isSessionSave: false });
    } else {
      setErrorMessage("Session Name Can't be Empty");
      this.setState({ sessionNameError: true });
    }
  };

  handleSessionNameChange = (e) => {
    const {
      jobEditItems,
      bulkEditData: { job },
    } = this.props;
    const updatedJob = { ...job, session_name: e.target.value };
    if (updatedJob.session_name === "") {
      setErrorMessage("Session Name Can't be Empty");
      this.setState({ sessionNameError: true });
    }
    jobEditItems(updatedJob);
  };

  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false });
    this.setState({ isSessionSave: false });
    const {
      jobEditItems,
      bulkEditData: { job, sessionName },
    } = this.props;
    this.setState({ sessionNameError: false });
    const updatedJob = { ...job, session_name: sessionName };
    jobEditItems(updatedJob);
  };

  handleIsSessionSave = () => {
    const {
      bulkEditData: { job },
    } = this.props;

    if (job.session_name.trim() !== "") {
      this.setState({ isDialogOpen: false });
      this.setState({ isSessionSave: true });
    } else {
      setErrorMessage("Session Name Can't be Empty");
      this.setState({ sessionNameError: true });
    }
  };

  onHandleCheckChange = (event, name) => {
    const {
      jobEditItems,
      bulkEditData: { job },
    } = this.props;
    let currentTrackUpdates = {};
    currentTrackUpdates = { ...job.track_common_updates };
    this.setState({ dirty: true });
    if (name === "composer") {
      currentTrackUpdates["isUpdateComposer"] = event.target.checked;
    } else if (name === "publisher") {
      currentTrackUpdates["isUpdatePublisher"] = event.target.checked;
    }
    const updatedJob = {
      ...job,
      track_common_updates: currentTrackUpdates,
    };

    jobEditItems(updatedJob);
  };

  //#endregion

  render() {
    const {
      classes,
      match: {
        params: { type: bulkEditType },
      },
      bulkEditData: {
        job: { selected_tracks, selected_albums, session_name },
        disabledField,
        exportingMessage,
        posting: { busy, message, errors },
        editing,
        sessionName,
        trackCommonEditing,
        albumEditing,
        albumCommonEditing,
        loading,
        listOfCountries,
        listOfOrigins,
        listOfDecades,
        listOfVocals,
        listOfAlbumTypes,
        isTrackDataEmpty,
        isAlbumDataEmpty,
        //albumTracksProdId,
      },
    } = this.props;
    const {
      currentTab,
      currentTrackIndex,
      trackIds,
      currentAlbumIndex,
      albumIds,
      editSingleTrack_bulkEdit,
      editAlbumAppendValues,
      editTrackAppendValues,
      editSingleAlbum_bulkEdit,
      isDialogOpen,
      isSessionSave,
      currentTrackId,
      currentAlbumId,
      invokedBulkJob,
      companyDetails,
      librarianNotes,
      prodNotes,
      trackLyrics,
      trackLibrarianNotes,
      trackTrackNotes,
      sessionNameError,
      applicationName,
      trackLyricsAppendFalse,
      trackLibrarianNotesAppendFalse,
      trackTrackNotesAppendFalse,
      albumCompanyDetailsAppendFalse,
      albumLibrarianNotesAppendFalse,
      tagConfirmationOpen,
      tagConfirmationMessage,
      applyTagChangesToAllTracks,
      albumProdNotesAppendFalse, keywords, displayingTracks, tagFilters,
      selectedKeywords, keywordsLoading, dirty, errorDialogOpen,
      errorDialogMessage, allCurrentKeywords, originalTracks } = this.state;

    let disableFields = false;
    if (bulkEditType === bulkEditStringTypes.TRACK) {
      if (selected_tracks && selected_tracks.length === 1) {
        disableFields = !loading && !editing;
      }
    } else {
      if (selected_albums && selected_albums.length === 1) {
        disableFields = !loading && !albumEditing;
      }
    }

    this.setColumns();

    return (

      <div>
        <Paper>
          {!busy && !loading && (
            <Confirm
              name="Publishing Bulk Edit"
              classes
              isOpen={this.state.messageOpen}
              title="Save Changes"
              content="Your changes have been saved. Would you like to publish them for processing?"
              confirm="Publish Now"
              cancel="Publish Later"
              onConfirm={(e) => this.handleBulkEditUpload(e)}
              onCancel={this.discardChanges}
              extentions={[
                {
                  text: "Publish Later",
                  action: () => {
                    this.setState({ messageOpen: false });
                  },
                },
              ]}
            />
          )}

          <div>
            <Dialog
              open={tagConfirmationOpen}
              onClose={this.handleCloseDialog}
              aria-labelledby="form-dialog-title"
              className="editSessionTitle">
              <DialogContent>
                <DialogContentText>
                  {tagConfirmationMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.applyTagChanges}
                  color="primary"
                  className={classes.dialogYesButton}>
                  Yes
                </Button>
                <Button
                  onClick={this.tagUpdateCancelled}
                  color="primary"
                  className={classes.dialogNoButton}>
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </div>

          <div>
            <Dialog
              open={errorDialogOpen}
              onClose={this.handleCloseErrorDialog}
              aria-labelledby="form-dialog-title"
              className="editSessionTitle">
              <DialogContent>
                <DialogContentText>
                  {errorDialogMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleCloseErrorDialog}
                  color="primary"
                  className={classes.dialogYesButton}>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </div>

          <div>
            <Dialog
              open={isSessionSave}
              onClose={this.handleCloseDialog}
              aria-labelledby="form-dialog-title"
              className="editSessionTitle">
              <DialogContent>
                <DialogContentText>
                  Do you want to update the changes made to this session?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleSaveSession}
                  color="primary"
                  className={classes.dialogYesButton}>
                  Yes, Update
                </Button>
                <Button
                  onClick={this.handleCloseDialog}
                  color="primary"
                  className={classes.dialogNoButton}>
                  No, Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </div>

          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={loading && exportingMessage ? true : false}
            message={exportingMessage}
            className={classes.snackbar}
          />
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={busy && message ? true : false}
            message={message ? message : ""}
            className={classes.snackbar}
          />
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={busy && errors ? true : false}
            message={errors ? errors : ""}
            className={classes.snackbar}
          />
          <div className={classes.additionalControls}>
            <div>
              <h2>
                {applicationName && `${applicationName} - `}
                {sessionName ? sessionName : ""}
              </h2>
              {loading || !sessionName ? (
                <div className={classes.overlay}>
                  <CircularProgress
                    size={20}
                    className={classes.bulkEditLoading}
                  />
                </div>
              ) : (
                <div className={classes.countofTracks}>
                  {currentTab == bulkEditTypesENUM.TRACK || currentTab == bulkEditTypesENUM.TAGGING ? (
                    <>
                      {applicationName &&
                        `${selected_tracks?.length && selected_tracks.length
                        } track(s)
                    selected.`}
                    </>
                  ) : (
                    <p>
                      {selected_albums?.length && selected_albums.length}{" "}
                      album(s) selected (
                      {invokedBulkJob &&
                        invokedBulkJob?.selected_albums_tracks_count}{" "}
                      track(s))
                    </p>
                  )}
                </div>
              )}
            </div>

            <div>
              {applicationName && (
                <Button
                  aria-label={"Edit Session Title"}
                  title={"Edit Session Title"}
                  disabled={disabledField || busy || disableFields}
                  onClick={this.handleOpenDialog}
                  className={classes.sessionEditButton}>
                  <MdEdit />
                </Button>
              )}
              <Dialog
                open={isDialogOpen}
                onClose={this.handleCloseDialog}
                aria-labelledby="form-dialog-title"
                className="editSessionTitle">
                <DialogTitle id="form-dialog-title">
                  Edit Session Title{" "}
                  <Button
                    aria-label="Edit Session Title"
                    className={classes.closeButton}
                    title="Close"
                    variant="contained"
                    onClick={this.handleCloseDialog}>
                    <CloseIcon />
                  </Button>
                </DialogTitle>

                <DialogContent>
                  <DialogContentText>Session Title:</DialogContentText>
                  <TextField
                    type="text"
                    variant="outlined"
                    placeholder="Session Name"
                    value={session_name ? session_name : ""}
                    onChange={this.handleSessionNameChange}
                    error={sessionNameError}
                    helperText={
                      sessionNameError ? "Session name is required" : ""
                    }
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    disabled={session_name === ""}
                    onClick={this.handleIsSessionSave}
                    color="primary"
                    className={classes.dialogYesButton}>
                    Done
                  </Button>
                </DialogActions>
              </Dialog>
            </div>

            <div className={classes.buttonControllers}>
              {currentTab == bulkEditTypesENUM.TRACK || currentTab == bulkEditTypesENUM.TAGGING ? (
                <>
                  <FormControlLabel
                    disabled={
                      disabledField ||
                      busy ||
                      (selected_tracks && selected_tracks.length === 1)
                    }
                    control={
                      <Switch
                        checked={editSingleTrack_bulkEdit}
                        onChange={this.handleEditSingleTrackChange}
                      />
                    }
                    label={"Bulk Edit"}
                  />
                  <FormControlLabel
                    disabled={disabledField || busy || isTrackDataEmpty}
                    control={
                      <Switch
                        checked={editTrackAppendValues}
                        onChange={this.handleTrackAppendToggleChange}
                      />
                    }
                    label={
                      <p>
                        Append values of{" "}
                        <span className={clsx(classes.append_text_color)}>
                          <b> +</b>{" "}
                        </span>{" "}
                        fields
                      </p>
                    }
                  />
                  <>
                    <Tooltip
                      title={
                        <>
                          All other fields will be overwritten with new values
                          <br />
                          (Fields with empty values will be ignored)
                        </>
                      }>
                      <Button
                        aria-label="Close Tags Window"
                        className={clsx(
                          classes.commonTopButton,
                          classes.buttonCustomSize,
                          classes.infoButton
                        )}>
                        <InfoIcon />
                      </Button>
                    </Tooltip>
                  </>
                </>
              ) : currentTab == bulkEditTypesENUM.TAGGING ? <></> : (
                <>
                  <FormControlLabel
                    disabled={
                      disabledField ||
                      busy ||
                      (selected_albums && selected_albums.length === 1)
                    }
                    control={
                      <Switch
                        checked={editSingleAlbum_bulkEdit}
                        onChange={this.handleEditSingleAlbumChange}
                      />
                    }
                    label={"Bulk Edit"}
                  />

                  <FormControlLabel
                    disabled={disabledField || busy || isAlbumDataEmpty}
                    control={
                      <Switch
                        checked={editAlbumAppendValues}
                        onChange={this.handleAlbumAppendToggleChange}
                      />
                    }
                    label={
                      <p>
                        Append values of{" "}
                        <span className={clsx(classes.append_text_color)}>
                          <b> +</b>{" "}
                        </span>{" "}
                        fields
                      </p>
                    }
                  />
                  <>
                    <Tooltip
                      title={
                        <>
                          All other fields will be overwritten with new values
                          <br />
                          (Fields with empty values will be ignored)
                        </>
                      }>
                      <Button
                        aria-label="Close Tags Window"
                        className={clsx(
                          classes.commonTopButton,
                          classes.buttonCustomSize,
                          classes.infoButton
                        )}>
                        <InfoIcon />
                      </Button>
                    </Tooltip>
                  </>
                </>
              )}

              <Button
                onClick={this.handleSaveUpdateData}
                variant="contained"
                color="primary"
                // disabled={busy || disabledField || disableFields ? true : false}
                disabled={!dirty || disabledField || disableFields
                  // busy ||

                  // disableFields ||
                  // isTrackDataEmpty ||
                  // isAlbumDataEmpty
                }
                className={classes.globalCreateSaveButton}>
                Save
              </Button>
            </div>
          </div>
          <div className={classes.tabsContainer}>
            <Tabs
              value={currentTab}
              onChange={this.handleTabChange}
              aria-label="Bulk Edit Tabs">
              {bulkEditType !== bulkEditStringTypes.TRACK &&
                selected_albums?.length &&
                selected_albums.length && (
                  <Tab
                    disabled={disabledField}
                    value={bulkEditTypesENUM.ALBUM}
                    label="Album Metadata"
                  />
                )}

              {selected_tracks?.length > 0 && (
                <Tab
                  disabled={disabledField}
                  value={bulkEditTypesENUM.TRACK}
                  label="Track Metadata"
                />
              )}

              {selected_tracks?.length > 0 && editSingleTrack_bulkEdit && (
                <Tab
                  disabled={disabledField}
                  value={bulkEditTypesENUM.TAGGING}
                  label="Tagging"
                />
              )}
            </Tabs>

            {currentTab == bulkEditTypesENUM.TRACK &&
              selected_tracks &&
              selected_tracks.length > 1 &&
              !editSingleTrack_bulkEdit && (
                <>
                  <div className={classes.singleEdiCtontrollers}>
                    <span className={classes.tabText}>
                      {currentTrackIndex + 1} of {trackIds?.length}
                    </span>
                    <div className={classes.navigationContainer}>
                      <Button
                        disabled={
                          currentTrackIndex === 0 || disabledField || busy
                        }
                        onClick={this.handlePrevious}
                        className={classes.paginationPreviousButton}>
                        Previous
                      </Button>
                      <Button
                        disabled={
                          currentTrackIndex === trackIds?.length - 1 ||
                          disabledField ||
                          busy
                        }
                        onClick={this.handleNext}
                        className={classes.paginationNextButton}>
                        Next
                      </Button>
                    </div>
                  </div>
                </>
              )}

            {(loading || !sessionName) && (
              <div className={classes.overlay}>
                <CircularProgress
                  size={20}
                  className={classes.bulkEditLoading}
                />
              </div>
            )}

            {currentTab == bulkEditTypesENUM.ALBUM &&
              selected_albums &&
              selected_albums.length > 1 &&
              !editSingleAlbum_bulkEdit && (
                <>
                  <div className={classes.singleEdiCtontrollers}>
                    <span className={classes.tabText}>
                      {currentAlbumIndex + 1} of {albumIds?.length}
                    </span>
                    <div className={classes.navigationContainer}>
                      <Button
                        disabled={
                          currentAlbumIndex === 0 || disabledField || busy
                        }
                        onClick={this.handlePrevious}
                        className={classes.paginationButton}>
                        Previous
                      </Button>
                      <Button
                        disabled={
                          currentAlbumIndex === albumIds?.length - 1 ||
                          disabledField ||
                          busy
                        }
                        onClick={this.handleNext}
                        className={classes.paginationButton}>
                        Next
                      </Button>
                    </div>
                  </div>
                </>
              )}
          </div>
          {currentTab === 0 && (
            <Paper className={classes.globalCreateBody}>
              <Grid container className={classes.bulkEditInput}>
                <div>
                  <div
                    className={clsx(
                      classes.globalCreateContentWrapper,
                      classes.bulkUpdateGrid
                    )}>
                    {(selected_albums && selected_albums.length === 1) ||
                      !editSingleAlbum_bulkEdit ? (
                      <AlbumSingleSpecificUpdates
                        {...this.props}
                        loading={loading}
                        albumEditing={albumEditing}
                        handleEditPicture={this.handleEditPicture}
                        onDrop={this.onDrop}
                        handleAlbumValuesChange={this.handleAlbumValuesChange}
                        countries={listOfCountries}
                        vocals={listOfVocals}
                        albumType={listOfAlbumTypes}
                        currentAlbumId={currentAlbumId}
                        companyDetails={companyDetails}
                        librarianNotes={librarianNotes}
                        prodNotes={prodNotes}
                        editAlbumAppendValues={editAlbumAppendValues}
                        handleAlbumRefreshValues={this.handleAlbumRefreshValues}
                        albumCompanyDetailsAppendFalse={
                          albumCompanyDetailsAppendFalse
                        }
                        albumLibrarianNotesAppendFalse={
                          albumLibrarianNotesAppendFalse
                        }
                        albumProdNotesAppendFalse={albumProdNotesAppendFalse}
                        handleAlbumAddChip={this.handleAlbumAddChip}
                        handleAlbumDeleteChip={this.handleAlbumDeleteChip}
                        handleRemoveImage={this.handleRemoveImage}
                      />
                    ) : (
                      <AlbumCommonUpdates
                        {...this.props}
                        handleAlbumCommonValueChange={
                          this.handleAlbumCommonValueChange
                        }
                        loading={loading}
                        albumCommonEditing={albumCommonEditing}
                        editAlbumAppendValues={editAlbumAppendValues}
                        countries={listOfCountries}
                        albumType={listOfAlbumTypes}
                        vocals={listOfVocals}
                        handleCommonAlbumRefreshValues={
                          this.handleCommonAlbumRefreshValues
                        }
                        handleCommonAlbumAddChip={this.handleCommonAlbumAddChip}
                        handleCommonAlbumDeleteChip={
                          this.handleCommonAlbumDeleteChip
                        }
                      />
                    )}
                  </div>
                </div>
              </Grid>
            </Paper>
          )}
          {currentTab === 1 && (
            <Paper className={classes.globalCreateBody}>
              <Grid container className={classes.bulkEditInput}>
                <div>
                  <div
                    className={clsx(
                      classes.globalCreateContentWrapper,
                      classes.bulkUpdateGrid
                    )}>
                    {(selected_tracks && selected_tracks.length === 1) ||
                      !editSingleTrack_bulkEdit ? (
                      <TracksSingleSpecificUpdates
                        {...this.props}
                        loading={loading}
                        editing={editing}
                        handleKeywordChange={this.handleKeywordChange}
                        handleTrackValueChange={this.handleTrackValueChange}
                        countries={listOfCountries}
                        currentTrackId={currentTrackId}
                        origins={listOfOrigins}
                        decades={listOfDecades}
                        vocals={listOfVocals}
                        trackLyrics={trackLyrics}
                        trackLibrarianNotes={trackLibrarianNotes}
                        trackTrackNotes={trackTrackNotes}
                        trackLyricsAppendFalse={trackLyricsAppendFalse}
                        trackLibrarianNotesAppendFalse={
                          trackLibrarianNotesAppendFalse
                        }
                        trackTrackNotesAppendFalse={trackTrackNotesAppendFalse}
                        editTrackAppendValues={editTrackAppendValues}
                        handleTrackRefreshValues={this.handleTrackRefreshValues}
                        handleTrackAddChip={this.handleTrackAddChip}
                        handleTrackDeleteChip={this.handleTrackDeleteChip}
                      // validationErrors={validationErrors}
                      />
                    ) : (
                      <TracksCommonUpdates
                        {...this.props}
                        loading={loading}
                        handleTrackCommonValueChange={
                          this.handleTrackCommonValueChange
                        }
                        countries={listOfCountries}
                        origins={listOfOrigins}
                        decades={listOfDecades}
                        vocals={listOfVocals}
                        trackCommonEditing={trackCommonEditing}
                        editTrackAppendValues={editTrackAppendValues}
                        onHandleCheckChange={this.onHandleCheckChange}
                        handleCommonTrackRefreshValues={
                          this.handleCommonTrackRefreshValues
                        }
                        handleTrackCommonAddChip={this.handleTrackCommonAddChip}
                        handleTrackCommonDeleteChip={
                          this.handleTrackCommonDeleteChip
                        }
                      />
                    )}
                  </div>
                </div>
              </Grid>
            </Paper>
          )}
          {currentTab === 3 && (
            <Paper className={classes.globalCreateBody}>
              <div className={classes.bulkTagEditInput}>
                <div>
                  <div className={clsx(
                    classes.globalCreateContentWrapper
                  )}>
                    <div style={{ height: '100%', width: '100%' }}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Autocomplete
                            multiple
                            options={keywords}
                            value={selectedKeywords}
                            loading={keywordsLoading}
                            onInputChange={this.handleKeywordInputChange}
                            onChange={this.onKeywordChange}
                            getOptionLabel={(o) => o.label || ''}
                            renderOption={(option) => (
                              <span>{option.label}
                                <span style={{ color: 'yellow' }}>{option.isNew && ' (new)'}</span>
                              </span>
                            )}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const tagProps = getTagProps({ index });
                                return (
                                  <Chip
                                    {...tagProps}
                                    label={option.label}
                                  />
                                );
                              })
                            }
                            renderInput={(params) => (
                              <>
                                <div className={clsx(classes.bulkTrackGrid)}>
                                  <div className={"singleBlock"}>
                                    <label className={classes.globalCreateLabel} htmlFor="keywords" aria-label="Input field for keywords"
                                    >  Keywords  :{" "}</label>

                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      id="keywords"
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                          <>
                                            {keywordsLoading ? <CircularProgress color="inherit" size={8} /> : null}
                                            {params.InputProps.endAdornment}
                                          </>
                                        ),
                                      }}
                                    />
                                   <Typography className={classes.keywordSubTitle} variant="h4">Enter a comma-delimited tag list, e.g., groovy, upbeat, dramatic, happy, moody.</Typography>
                                  </div>
                                </div>
                              </>
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <ButtonGroup
                            disableElevation
                            aria-label="Disabled button group"
                            className={classes.buttonGroup}
                          >
                            <Button disabled={!selectedKeywords.length} className={classes.globalCreateAddButton}
                              onClick={() => {
                                if (selectedKeywords.length > 0) {
                                  const list = selectedKeywords.map(k => `"${k.label}"`).join(", ");
                                  const plural = selectedKeywords.length > 1;
                                  const tracksToUpdate = applyTagChangesToAllTracks ? originalTracks : displayingTracks;
                                  this.tagUpdateConfirmation(
                                    `Are you sure you want to add the keyword${plural ? 's' : ''} ${list} to ${tracksToUpdate.length} track${tracksToUpdate.length === 1 ? '' : 's'} (only where missing)?`,
                                    "keywords_add"
                                  );
                                }
                              }}>
                              Add Tag(s)
                            </Button>
                            <span className={classes.seperatText}> or </span>
                            <Button disabled={!selectedKeywords.length} className={classes.globalCreateAddButton}
                              onClick={() => {
                                if (selectedKeywords.length > 0) {
                                  const list = selectedKeywords.map(k => `"${k.label}"`).join(", ");
                                  const plural = selectedKeywords.length > 1;
                                  const tracksToUpdate = applyTagChangesToAllTracks ? originalTracks : displayingTracks;
                                  this.tagUpdateConfirmation(
                                    `Are you sure you want to remove the keyword${plural ? 's' : ''} ${list} from ${tracksToUpdate.length} track${tracksToUpdate.length === 1 ? '' : 's'}?`,
                                    "keywords_remove"
                                  );
                                }
                              }}>
                              Remove Tag(s)
                            </Button>

                          </ButtonGroup>
                          {(selectedKeywords?.length > 0 && tagFilters?.length > 0) && (
                            <span className={classes.radioBlock}>
                              <FormControl component="fieldset">
                                <RadioGroup row aria-label="track selection method" defaultValue="top">
                                  <FormControlLabel
                                    disabled={!selectedKeywords?.length || !tagFilters?.length}
                                    checked={applyTagChangesToAllTracks}
                                    onChange={() => this.setState({ applyTagChangesToAllTracks: true })}
                                    name="radio-button-change-apply-to-all"
                                    inputProps={{ 'aria-label': 'apply to all track(s)' }}
                                    label={"Apply to all track(s)"}
                                    control={<Radio color="#04923F" />}
                                    labelPlacement="end"
                                  />
                                  <FormControlLabel
                                    disabled={!selectedKeywords?.length || !(tagFilters?.length)}
                                    checked={!applyTagChangesToAllTracks}
                                    onChange={() => this.setState({ applyTagChangesToAllTracks: false })}
                                    name="radio-button-change-apply-to-selected"
                                    inputProps={{ 'aria-label': 'apply to selected track(s)' }}
                                    label={"Apply to filtered track(s) only"}
                                    control={<Radio color="#04923F" />}
                                    labelPlacement="end"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </span>)}
                        </Grid>
                        <Grid item xs={12}>
                          <Typography className={classes.keywordTitle} variant="h4">Current keywords for group :</Typography>
                          {allCurrentKeywords.map((keyword) => (
                            <ButtonGroup style={{ margin: '2px 5px 2px 0px' }} variant="outlined" aria-label="Basic button group">
                              <Button className={classes.filterItem} title={`Click to select: ${keyword.value}`} variant="outlined" onClick={() => {
                                this.setState({ selectedKeywords: [...selectedKeywords.filter(k => k.label !== keyword.value), { type: 'keyword', label: keyword.value }] });
                              }}><span style={{color:keyword.count > 0 ? "#FFE600" : "#b3ac66"}}>{keyword.value}</span><span style={{ color: '#ffffff', width: "40px", textAlign: "right" }}>{keyword.count > 0 && ` (${keyword.count})`}</span></Button>
                              {(() => {
                                var keyExists = tagFilters.some(k => k.label === keyword.value);
                                var keyIcon = keyExists ?  <MdFilterAltOff /> :<MdFilterListAlt />;
                                var keyColor = keyExists ? "#13a650" : "#686868ff" ;
                                return (
                                  <Button title={`Click to ${keyExists ? 'remove' : 'add'} filter: ${keyword.value}`} className={classes.filterButton} disabled={!(keyword.count)} style={{ backgroundColor:keyColor, color: "#ffffff" }} variant="contained" onClick={(e) => {
                                    if (keyExists) {
                                      this.setState({ tagFilters: tagFilters.filter(k => k.label !== keyword.value) }, this.prepareTracksForDisplay);
                                    } else {
                                      this.setState({ tagFilters: [...tagFilters.filter(k => k.label !== keyword.value), { type: 'keyword', label: keyword.value }] }, this.prepareTracksForDisplay);
                                    }
                                  }}><>{keyIcon}</></Button>)
                              })()}
                            </ButtonGroup>
                          ))}
                        </Grid>
                        <Grid item sx={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <Typography className={classes.keywordTitle} variant="h4">Media items to be edited:</Typography>
                          <TableContainer
                            className={classes.discreteTableData}
                            component={Paper}
                          >
                            <Table
                              stickyHeader
                              className={clsx(classes.tableDataList, classes.tagsDisplayTable)}
                            >
                              <TableHead>
                                <TableRow>
                                  {this.columns.map((column, i) => (
                                    <TableHeaderCol
                                      columns={this.columns}
                                      key={`th${column.field}${i}`}
                                      {...this.props}
                                      column={column}
                                    />
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {displayingTracks.map((row) => {
                                  return (
                                    <TableRow
                                      key={row.id}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                      }}
                                      className={
                                        classes.tableUnfocusedRow
                                      }
                                    >
                                      {this.columns.map((c, i) => (
                                        <TableDataCol
                                          key={c.field + row.id}
                                          {...this.props}
                                          column={c}
                                          row={row}
                                          rowId={row.id}
                                          selected={false}
                                        />
                                      ))}
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </div>
              </div>
            </Paper>
          )}
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mlSessionUploadTrackReducer,
  updateData: state.mlTrackUpdateReducer,
  orgRuntime: state.orgRuntime,
  bulkEditData: state.bulkEdit,
  userData: state.user,
});

export default connect(mapStateToProps, {
  loadRuntime,
  bulkEditInvoke,
  search,
  albumSearch,
  setQuery,
  editItem,
  albumEditItem,
  bulkEditSave,
  jobEditItems,
  commonEditItem,
  albumCommonEditItem,
  showAutoMessage,
  bulkEditPublish,
  bulkEditUploadImage,
  getListOfCountries,
  getListOfOrigins,
  getListOfDecades,
  getListOfVocals,
  setErrorMessage,
  getValidationItems,
  getListOfAlbumTypes,
})(withStyles(styles)(BulkEdit));
